<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="request.IDRequest !== undefined" class="session-valid">
                    <div *ngIf="request.ProgressStatus > 0 && request.ProgressStatus < 9 && !startingVideoShow" class="row">
                        <div class="col-lg-12">
                            <ol class="stepper">
                                <li *ngIf="request.FKIDRequestType !== 6" [ngClass]="{ 'active': request.ProgressStatus === 1 }">Informazioni</li>
                                <li *ngIf="request.FKIDRequestType === 6" [ngClass]="{ 'active': request.ProgressStatus === 1 && !hyperDepreciationStep }">Informazioni Sabatini</li>
                                <li *ngIf="request.FKIDRequestType === 6" [ngClass]="{ 'active': request.ProgressStatus === 1 && hyperDepreciationStep }">Informazioni Iperammortamento 4.0</li>
                                <li *ngIf="!request.Simplified" [ngClass]="{ 'active': request.ProgressStatus === 2 }">
                                    Dati
                                </li>
                                <li [ngClass]="{ 'active': request.ProgressStatus === 3 }">Accettazione</li>
                                <li *ngIf="request.FKIDRequestType !== 6" [ngClass]="{ 'active': request.ProgressStatus === 4 }">
                                    Contratto{{ (request.FKIDRequestType === 5 ? ' di consulenza' : '') }}
                                </li>
                                <li *ngIf="request.FKIDRequestType === 6" [ngClass]="{ 'active': request.ProgressStatus === 4 && !hyperDepreciationContractStep }">
                                    Contratto Sabatini
                                </li>
                                <li *ngIf="request.FKIDRequestType === 6" [ngClass]="{ 'active': request.ProgressStatus === 4 && hyperDepreciationContractStep }">
                                    Contratto Iperammortamento 4.0
                                </li>
                                <li *ngIf="request.FKIDRequestType !== 5"
                                    [ngClass]="{ 'active': request.ProgressStatus === 5 }">Liberatoria
                                </li>
                                <li *ngIf="request.FKIDRequestType !== 5 && request.FKIDRequestType !== 7"
                                    [ngClass]="{ 'active': request.ProgressStatus === 6 }">Procura
                                </li>
                                <li *ngIf="request.FKIDRequestType !== 5 && request.FKIDRequestType !== 7"
                                    [ngClass]="{ 'active': request.ProgressStatus === 7 }">Privacy
                                </li>
                                <li [ngClass]="{ 'active': request.ProgressStatus === 8 }">Documenti</li>
                            </ol>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 0" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2" style="color: black;">
                            <div class="form-group m-b-30">
                                <label class="col-12 control-label">
                                    Hai già concluso almeno una pratica con Tevanpal?
                                </label>
                                <div class="col-12 text-center">
                                    <mat-radio-group id="simplified-request-condition"
                                                     name="simplified-request-condition"
                                                     required
                                                     [color]="'primary'"
                                                     [(ngModel)]="simplifiedRequestSteps.step1">
                                        <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                          [value]="radioBasicOption.value">
                                            <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div *ngIf="simplifiedRequestSteps.step1" class="form-group m-b-30" style="height: 58px;">
                                <label for="simplified-request-vat" class="col-sm-3 control-label">Partita IVA</label>
                                <div class="col-sm-7 prepend-icon">
                                    <input type="text"
                                           id="simplified-request-vat"
                                           name="simplified-request-vat"
                                           class="form-control"
                                           placeholder="Inserisci partita IVA"
                                           minlength="2"
                                           required
                                           autocomplete="off"
                                           [(ngModel)]="customer.VATNumber"
                                           #simplifiedRequestVat="ngModel">
                                    <i class="icon-list" style="padding-left: 22px;"></i>
                                    <div [hidden]="simplifiedRequestVat.valid || simplifiedRequestVat.pristine"
                                         class="form-error valid">
                                        Inserisci almeno 2 caratteri.
                                    </div>
                                    <div [hidden]="simplifiedRequestSteps.step2 !== -1"
                                         class="form-error valid">
                                        Partita IVA non trovata.
                                    </div>
                                    <div [hidden]="simplifiedRequestSteps.step2 !== 1"
                                         class="form-success valid" style="color: #28a745">
                                        Partita IVA trovata.
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <button type="button"
                                            class="btn btn-embossed btn-success"
                                            (click)="checkVATNumber()">
                                        <i class="glyphicon glyphicon-check"></i>Verifica
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="simplifiedRequestSteps.step1 && simplifiedRequestSteps.step2 === 1"
                                 class="form-group m-b-30">
                                <label class="col-12 control-label">
                                    Sono variati i dati societari dell’impresa?
                                </label>
                                <div class="col-12 text-center">
                                    <mat-radio-group id="simplified-request-variation"
                                                     name="simplified-request-variation"
                                                     required
                                                     [color]="'primary'"
                                                     [(ngModel)]="simplifiedRequestSteps.step3">
                                        <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                          [value]="radioBasicOption.value">
                                            <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <div *ngIf="simplifiedRequestSteps.step2 === 1 && !simplifiedRequestSteps.step3" class="form-group m-b-30">
                                <label class="col-12 control-label">
                                    Rispetto all’ultima documentazione trasmessa alla nostra società, il Bilancio e gli ULA sono variati?
                                </label>
                                <div class="col-12 text-center">
                                    <mat-radio-group id="simplified-request-last-balance"
                                                     name="simplified-request-last-balance"
                                                     [color]="'primary'"
                                                     [(ngModel)]="simplifiedRequestSteps.lastBalance">
                                        <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                          [value]="radioBasicOption.value">
                                            <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <div *ngIf="simplifiedRequestSteps.lastBalance && simplifiedRequestSteps.step1 && !simplifiedRequestSteps.step3"
                                 class="form-group">
                                <label for="ula-last-balance" class="col-sm-3 control-label">ULA Ultimo Bilancio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="ula-last-balance-step1"
                                           name="ula-last-balance-step1"
                                           class="form-control"
                                           placeholder="Inserisci ULA relative all'ultimo bilancio approvato"
                                           required
                                           autocomplete="off"
                                           [ngClass]="{
                                            'form-error': ulaLastBalance.invalid && ulaLastBalance.touched,
                                            'form-success': ulaLastBalance.valid && ulaLastBalance.touched
                                       }"
                                           [(ngModel)]="customer.ULALastBalance"
                                           #ulaLastBalance="ngModel">
                                    <i class="icon-info" style="padding-left: 22px;"></i>
                                    <div class="info-box">
                                        <i class="fa fa-info-circle"></i>
                                        Unità lavorative anno, ovvero il numero medio di dipendenti occupati
                                        nell'impresa relativamente all'ultimo Bilancio/Modello Unico depositato.
                                    </div>
                                    <div [hidden]="ulaLastBalance.valid || !ulaLastBalance.touched"
                                         class="form-error valid">
                                        Il campo è richiesto.
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="simplifiedRequestSteps.lastBalance && simplifiedRequestSteps.step1 && !simplifiedRequestSteps.step3" class="form-group m-b-30">
                                <div class="row m-b-10" style="padding-right: 15px; padding-left: 15px;">
                                    <label class="col-3 m-t-12" class="col-sm-3 control-label">Ultimo Bilancio approvato</label>
                                    <div class="col-9 mb-3">
                                        <div *ngIf="!documentList['2'] || documentList['2'].length === 0"
                                             class="custom-file m-b-12 step0-custom-file">
                                            <input type="file"
                                                   class="custom-file-input"
                                                   id="last-balance-step1"
                                                   name="last-balance-step1"
                                                   (change)="onLastBalanceStep1FileSelected($event)"
                                                   required>
                                            <label class="custom-file-label"
                                                   for="last-balance-step1">{{ fileName[2] || 'Nessun file selezionato' }}</label>
                                        </div>
                                        <div *ngIf="documentList['2'].length > 0" class="width-100p m-t-10">
                                            <ul style="list-style-type: none;">
                                                <li *ngFor="let documentDetail of documentList['2']">
                                                    <span class="label label-success"
                                                          style="font-size: 12px; margin-right: auto;">
                                                            {{ documentDetail.Path }}
                                                    </span>
                                                    <button (click)="deleteDocument(documentDetail)"
                                                            type="button"
                                                            class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="info-box" style="width: 100%;">
                                            <i class="fa fa-info-circle"></i>
                                            Formato accettato PDF/DOCX, non ammessa la scannerizzazione del documento.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!simplifiedRequestSteps.step1 || simplifiedRequestSteps.step3" class="form-group m-b-30">
                                <div *ngIf="!request.Simplified" class="row m-b-10" style="padding-right: 15px; padding-left: 15px;">
                                    <label class="col-3 m-t-12" class="col-sm-3 control-label">Visura Camerale aggiornata</label>
                                    <div class="col-9 mb-3">
                                        <div class="custom-file m-b-12 step0-custom-file">
                                            <input type="file"
                                                   class="custom-file-input"
                                                   id="chamber-commerce-certificate-step0"
                                                   name="chamber-commerce-certificate-step0"
                                                   (change)="onVisuraFileSelected($event)"
                                                   required>
                                            <label class="custom-file-label"
                                                   for="chamber-commerce-certificate-step0">{{ fileName[1] || 'Nessun file selezionato' }}</label>
                                        </div>
                                        <div class="info-box" style="width: 100%;">
                                            <i class="fa fa-info-circle"></i>
                                            Formato accettato PDF, non ammessa la scannerizzazione del documento.
                                        </div>
                                    </div>
                                    <div *ngIf="visuraParsingResult !== null" class="col-12 m-t-12">
                                        <label class="col-12 control-label">
                                            Dati rilevati:
                                        </label>
                                        <p *ngFor="let visuraSuccess of visuraParsingResult.success" style="margin-bottom: 0; padding-left: 15px;">
                                            <span *ngIf="editingVisuraField !== visuraSuccess.key">
                                                {{ visuraSuccess.title }}: {{ visuraSuccess.value }}
                                                <button type="button"
                                                        class="btn btn-xs btn-info btn-edit-visura"
                                                        (click)="startEditVisura(visuraSuccess)">
                                                    <i class="fa fa-pencil icon-edit-visura"></i>
                                                </button>
                                            </span>
                                            <span *ngIf="editingVisuraField === visuraSuccess.key" class="form-group" style="margin-bottom: 5px; display: inline-block;">
                                                {{ visuraSuccess.title }}:
                                                <input type="text"
                                                       class="form-control input-edit-visura"
                                                       [(ngModel)]="editingVisuraValue">
                                                <button type="button"
                                                        class="btn btn-xs btn-success btn-save-visura"
                                                        (click)="saveEditVisura(visuraSuccess)">
                                                    <i class="fa fa-check icon-save-visura"></i>
                                                </button>
                                            </span>
                                        </p>
                                        <p *ngIf="visuraParsingResult!.success.length === 0" style="margin-bottom: 0; padding-left: 15px;">
                                            <span style="font-style: italic;">
                                                Nessuno
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="visuraParsingResult !== null" class="text-center">
                                <mat-checkbox color="primary" [(ngModel)]="checkboxVisuraData">
                                    Confermo che i dati rilevati sono corretti
                                </mat-checkbox>
                            </div>

                            <div *ngIf="getMissingFieldsStep0().length > 0"
                                 class="alert alert-danger text-left m-t-30">
                                <strong>Devi ancora completare i seguenti dati per proseguire:</strong>
                                <ul style="margin-bottom: 0; padding-left: 20px;">
                                    <li *ngFor="let field of getMissingFieldsStep0()">
                                        {{ field }}
                                    </li>
                                </ul>
                            </div>

                            <div *ngIf="stepAdvanceError" class="alert alert-danger text-left m-t-30">
                                {{ stepAdvanceError }}
                            </div>

                            <div class="text-center m-t-20">
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        [disabled]="!canAdvanceFromCurrentStep() || loadingCondition"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 1 && startingVideoShow" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2" style="color: black;">
                            <div class="text-center">
                                <video style="width: 100%;" controls controlsList="nodownload">
                                    <source [src]="serverAddress + 'video/stream/16'" type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        (click)="startingVideoShow = false">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 1 && !startingVideoShow" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div *ngIf="request.FKIDRequestType === 1 || request.FKIDRequestType === 4 || (request.FKIDRequestType === 6 && !hyperDepreciationStep)"
                             class="col-sm-8 offset-sm-2" style="color: black;">
                            <div *ngIf="request.FKIDRequestType === 1 || request.FKIDRequestType === 6" class="row m-b-10">
                                <div class="col-md-12 text-center">
                                    <p class="text-center">Prima di compilare i campi ti consigliamo di vedere le seguenti video pillole informative.</p>
                                    <button class="btn btn-embossed btn-success" style="margin-bottom: 10px !important;" (click)="openVideoModal(15)">
                                        <i class="fa fa-video-camera"></i>Video Pillola Informativa 1
                                    </button>
                                    <button class="btn btn-embossed btn-success" style="margin-bottom: 10px !important;" (click)="openVideoModal(8)">
                                        <i class="fa fa-video-camera"></i>Video Pillola Informativa 2
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <p>Gentile Cliente,</p>
                            <p>
                                Si ricorda che i beni oggetto della "Domanda Nuova Sabatini" devono essere finalizzati all’ampliamento della flotta aziendale e non alla mera sostituzione. Inoltre, tali beni non potranno essere venduti nei tre anni successivi al completamento dell’investimento.
                            </p>
                            <p>
                                Le ricordiamo che, secondo la normativa Sabatini, <strong>gli investimenti possono essere
                                avviati solo dopo la presentazione della domanda</strong>. Pertanto, i documenti di acquisto devono essere firmati e datati successivamente a tale presentazione, pena la revoca del contributo. Eventuali anticipi e/o caparre potranno essere versati/incassati solo dopo la presentazione della domanda; in caso contrario, il contributo sarà revocato nella fase di rendicontazione. I beni oggetto dell’investimento devono essere necessariamente nuovi e non usati o rigenerati, e qualsiasi permuta o sostituzione comporterà la decadenza del beneficio.
                            </p>
                            <p>
                                La informiamo inoltre che, per la <strong>Sabatini INDUSTRIA 4.0</strong>, in caso di mancata realizzazione dell'<strong>interconnessione</strong> entro il momento della prima richiesta di erogazione del contributo, l'intero importo stanziato dal Mise sarà oggetto di revoca e non sarà possibile convertirlo nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                La informiamo inoltre che, per la <strong>Sabatini GREEN</strong>, se i beni oggetto dell'agevolazione o la documentazione di certificazione non risultano conformi ai requisiti previsti dall'allegato 6/c scaricabile dal sito del Mise (“Elenco certificazioni ambientali valide ai fini dell’ammissibilità dei cosiddetti investimenti green”), il contributo sarà completamente annullato e non potrà essere convertito nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                Il costo per la gestione dell'intera pratica "Nuova Sabatini" è riportato di seguito:
                            </p>
                            <p *ngIf="request.PaymentDetails !== null && request.PaymentDetails !== ''">{{ request.PaymentDetails }}</p>
                            <p *ngIf="request.PaymentDetails === null || request.PaymentDetails === ''">
                                il costo è pari a {{ request.PaymentCost1 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (più oneri di legge) divisi in {{ request.PaymentCost1 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (1° parte) e {{ request.PaymentCost1 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di {{ (request.PaymentCost1 / 2) * 1.22 | currency:'EUR':'':'1.2-2':'it-IT' }} euro ({{ request.PaymentCost1 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento "Domanda Nuova Sabatini" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.
                            </p>
                            <p>
                                Verrà emessa una fattura di acconto dopo la firma del contratto di consulenza (1ª fase), e una fattura di saldo al termine della rendicontazione (2ª fase).
                            </p>
                            <p>
                                <strong>Nota bene: Ogni variazione dei dati societari (ad esempio: IBAN, sede legale, quote societarie, ecc.) deve essere tempestivamente comunicata al Ministero. Sarà vostra cura comunicarci l’eventuale variazione.</strong>
                            </p>

                            <div style="text-align: center;">
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[0]">
                                    Dichiaro di aver letto e compreso l’informativa
                                </mat-checkbox>
                            </div>

                            <div *ngIf="request.FKIDRequestType !== 6" class="text-center m-t-40">
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        [disabled] = "!checkboxRelease[0]"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>

                            <div *ngIf="request.FKIDRequestType === 6" class="text-center m-t-40">
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        [disabled] = "!checkboxRelease[0]"
                                        (click)="goStepForwardInfo()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="request.FKIDRequestType === 2" class="col-sm-8 offset-sm-2" style="color: black;">
                            <p>Gentile Cliente,</p>
                            <p>
                                seguendo la procedura indicata nel presente modulo sarà possibile predisporre la
                                <strong>“Domanda Nuova Sabatini"</strong>, volta ad accedere al contributo economico
                                messo a disposizione
                                dal Ministero delle Imprese e del Made in Italy, con l’obiettivo di facilitare l’accesso
                                al credito per le aziende italiane, e la pratica denominata <strong>"Credito d'imposta
                                4.0"</strong>.
                            </p>
                            <p>
                                A tal fine, sarà necessario fornire una serie di documenti che Le verranno richiesti nei
                                passaggi successivi attraverso la piattaforma da noi gestita.
                            </p>
                            <p>
                                Si ricorda che i beni oggetto della "Domanda Nuova Sabatini" devono essere finalizzati
                                all’ampliamento della flotta aziendale e non alla mera sostituzione. Inoltre, tali beni
                                non potranno essere venduti nei tre anni successivi al completamento dell’investimento.
                            </p>
                            <p>
                                Le ricordiamo che, secondo la normativa Sabatini, gli investimenti possono essere
                                avviati solo dopo la presentazione della domanda. Pertanto, i documenti di acquisto
                                devono essere firmati e datati successivamente a tale presentazione, pena la revoca del
                                contributo. Eventuali anticipi e/o caparre potranno essere versati/incassati solo dopo
                                la presentazione della domanda; in caso contrario, il contributo sarà revocato nella
                                fase di rendicontazione. I beni oggetto dell’investimento devono essere necessariamente
                                nuovi e non usati o rigenerati, e qualsiasi permuta o sostituzione comporterà la
                                decadenza del beneficio.
                            </p>
                            <p>
                                La informiamo inoltre che, per la Sabatini INDUSTRIA 4.0, in caso di mancata
                                realizzazione dell'integrazione o interconnessione entro il momento della prima
                                richiesta di erogazione del contributo, l'intero importo stanziato dal Mise sarà oggetto
                                di revoca e non sarà possibile convertirlo nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                La informiamo inoltre che, per la Sabatini GREEN, se i beni oggetto dell'agevolazione o
                                la documentazione di certificazione non risultano conformi ai requisiti previsti
                                dall'allegato 6/c scaricabile dal sito del Mise (“Elenco certificazioni ambientali
                                valide ai fini dell’ammissibilità dei cosidetti investimenti green”), il contributo sarà
                                completamente annullato e non potrà essere convertito nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                Inoltre la informiamo che attualmente il "Credito d'imposta 4.0" è pari al 20%
                                dell'importo dell'investimento (esclusa Iva) , da compensare in F24 in 3 o più anni a
                                partire dalla data di interconnessione del bene. La pratica dovrà essere inviata tramite
                                il portale del GSE ed è divisa in due fasi: "comunicazione ex ante" (da inviare prima
                                dell'avvio dell'investimento) e "comunicazione ex post" (da inviare a completamento
                                dell'investimento). Si evidenzia a tal proposito che l'impresa dovrà necessariamente
                                avvisare il Team di Tevanpal quando il bene verrà consegnato e interconnesso. Se il bene
                                oggetto di investimento in 4.0 ha un valore superiore a 300.000,00 euro, è fondamentale
                                far redigere una perizia da un ingegnere o un perito industriale. Qualora il valore
                                dell’investimento dovesse essere inferiore ai 300.000,00 euro è necessario far redigere
                                una dichiarazione dal legale rappresentante indicando la data certa di interconnessione
                                del bene 4.0.
                            </p>
                            <p>
                                Costi per la gestione della pratica: Il costo per la gestione dell’intera pratica
                                "Domanda Nuova
                                Sabatini" e "Credito d'imposta 4.0" è suddiviso in fasce, in base al valore totale dei
                                beni richiesti, nel vostro caso:
                            </p>
                            <p>{{ request.PaymentDetails }}</p>
                            <p>
                                Verrà emessa una fattura di acconto dopo la firma del contratto di consulenza (1ª fase),
                                e
                                una fattura di saldo al termine della rendicontazione dell’investimento effettuato (2ª
                                fase).
                            </p>
                            <p>
                                Nota bene: Ogni variazione dei dati societari (ad esempio: IBAN, sede legale, quote
                                societarie, ecc.) deve essere tempestivamente comunicata al Ministero. Sarà vostra cura
                                comunicarci l’eventuale variazione.
                            </p>

                            <div class="text-center m-t-40">
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="request.FKIDRequestType === 3" class="col-sm-8 offset-sm-2" style="color: black;">
                            <p>Gentile Cliente,</p>
                            <p>
                                seguendo la procedura indicata nel presente modulo sarà possibile predisporre la pratica
                                denominata “Credito d’imposta 5.0” e “Domanda Nuova Sabatini”.
                            </p>
                            <p>
                                In riferimento al <strong>“Credito d’imposta 5.0”</strong>, si specifica che si tratta
                                di
                                un’agevolazione, sotto forma di credito d’imposta, che viene riconosciuta sui progetti
                                di innovazione avviati dal 1 gennaio
                                2024 e completati entro il 31 dicembre 2025. L’obiettivo è quello di investire in beni
                                materiali e immateriali nuovi strumentali all’esercizio d’impresa (Allegati A e B alla
                                legge 11
                                dicembre 2016 n. 232), che oltre ad avere caratteristiche tecnologiche, permettano di
                                conseguire anche una riduzione dei consumi energetici.<br/>
                                Gli investimenti sopra menzionati sono considerati trainanti poiché, grazie alla loro
                                implementazione e al conseguente raggiungimento della riduzione minima dei consumi,
                                consentono l’accesso a ulteriori agevolazioni opzionali. Tali agevolazioni riguardano
                                gli
                                investimenti finalizzati all’autoproduzione o autoconsumo da fonti rinnovabili (ad es.
                                impianto fotovoltaico), nonché le spese per la formazione dei propri dipendenti
                                orientata
                                all’acquisizione o al consolidamento delle competenze necessarie per la transizione
                                digitale
                                ed energetica dei processi produttivi.<br/>
                                Attualmente il “Credito d’imposta 5.0” presenta aliquote differenti in base alla
                                percentuale di
                                riduzione dei consumi energetici che si consegue. Si evidenzia che il credito d’imposta
                                spettante è utilizzabile esclusivamente in compensazione nel modello F24 entro la data
                                del
                                31/12/2025. L’eventuale credito non ancora utilizzato alla data del 31/12/2025 è
                                riportato in
                                avanti ed è utilizzabile in 5 quote annuali di pari importo.<br/>
                                L’impresa è tenuta a conservare, per le attività di vigilanza e controllo, tutta la
                                documentazione necessaria all’accertamento della correttezza e veridicità delle
                                dichiarazioni, delle informazioni e dei dati forniti.
                                In particolare, l’impresa dovrà conservare tutta la documentazione necessaria a
                                dimostrare
                                l’effettivo sostenimento dell’investimento (ad es. fatture, documenti di trasporto, e
                                altri
                                documenti relativi all’acquisizione dei beni agevolati. Tutti i documenti menzionati
                                dovranno
                                contenere l’espresso riferimento alle disposizioni normative relative al “Piano
                                Industria 5.0”),
                                la certificazione contabile, la perizia asseverata per quanto concerne l’attestazione
                                dei requisiti 4.0
                                dei beni interconnessi, le certificazioni ex ante ed ex post dell’ingegnere energetico
                                (Ege/Esco), il
                                verbale di collaudo e l’avvenuta interconnessione.
                            </p>
                            <p>
                                Relativamente all’attività di controllo, il Ministero, insieme al GSE, verifica sia la
                                correttezza
                                formale delle certificazioni rilasciate, sia la corrispondenza del contenuto delle
                                certificazioni
                                medesime alle disposizioni normative, nonché la verifica, in capo ai soggetti abilitati
                                al
                                rilascio delle certificazioni, del possesso dei requisiti previsti dall’articolo 15 del
                                decreto
                                attuativo del 26 luglio 2024 relativo a “Transizione 5.0”, ivi compreso il possesso di
                                idonee
                                coperture assicurative.
                            </p>
                            <p>
                                La informiamo inoltre che il Credito d’imposta 5.0, prevede che l’interconnessione del
                                bene
                                oggetto di investimento sia mantenuta per tutto il periodo di sorveglianza. Attualmente
                                è
                                previsto che il diritto all’utilizzo del Credito d’imposta 5.0 viene meno se i beni
                                vengono
                                ceduti entro il 31 dicembre del quinto anno successivo al completamento del progetto di
                                innovazione, ma anche se nello stesso periodo non viene mantenuto il risparmio
                                energetico
                                ottenuto.
                            </p>
                            <p>
                                In riferimento invece alla <strong>“Domanda Nuova Sabatini”</strong>, si specifica che i
                                beni oggetto di
                                investimento devono essere finalizzati all’ampliamento aziendale e non alla mera
                                sostituzione. Inoltre, tali beni non potranno essere venduti nei tre anni successivi al
                                completamento dell’investimento.
                            </p>
                            <p>
                                Le ricordiamo che, secondo la normativa Sabatini, gli investimenti possono essere
                                avviati solo dopo la presentazione della domanda. Pertanto, i documenti di acquisto
                                devono essere firmati e datati successivamente a tale presentazione, pena la revoca del
                                contributo. Eventuali anticipi e/o caparre potranno essere versati/incassati solo dopo
                                la presentazione della domanda; in caso contrario, il contributo sarà revocato nella
                                fase di rendicontazione. I beni oggetto dell’investimento devono essere necessariamente
                                nuovi e non usati o rigenerati, e qualsiasi permuta o sostituzione comporterà la
                                decadenza del beneficio.
                            </p>
                            <p>
                                La informiamo inoltre che, per la Sabatini INDUSTRIA 4.0, in caso di mancata
                                realizzazione dell'integrazione o interconnessione entro il momento della prima
                                richiesta di erogazione del contributo, l'intero importo stanziato dal Mise sarà oggetto
                                di revoca e non sarà possibile convertirlo nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                La informiamo inoltre che, per la Sabatini GREEN, se i beni oggetto dell'agevolazione o
                                la documentazione di certificazione non risultano conformi ai requisiti previsti
                                dall'allegato 6/c scaricabile dal sito del Mise (“Elenco certificazioni ambientali
                                valide ai fini dell’ammissibilità dei cosiddetti investimenti green”), il contributo
                                sarà completamente annullato e non potrà essere convertito nella “Sabatini ordinaria”.
                            </p>
                            <p>
                                Nota bene: Ogni variazione dei dati societari (ad esempio: IBAN, sede legale, quote
                                societarie, ecc.) deve essere tempestivamente comunicata al Ministero. Sarà vostra cura
                                comunicarci l’eventuale variazione.
                            </p>
                            <p>
                                Il costo, di nostra spettanza, per la gestione dell’intera pratica “Credito d’imposta
                                5.0”:
                            </p>
                            <p>{{ request.PaymentDetails }}</p>
                            <p>
                                Verrà emessa una fattura di acconto dopo la firma del contratto di consulenza (1ª fase),
                                una
                                seconda fattura al termine della presentazione della ricevuta di avvenuta consegna della
                                “comunicazione intermedia” (2° fase) e una fattura di saldo al termine della
                                rendicontazione
                                (3° fase).
                            </p>
                            <p>
                                Nota bene: Ogni variazione dei dati societari (ad esempio: IBAN, sede legale, quote
                                societarie, ecc.) e ogni variazione relativa all’investimento deve essere
                                tempestivamente
                                comunicata al Ministero/GSE. Sarà vostra cura comunicarci l’eventuale variazione.
                            </p>

                            <div class="text-center m-t-40">
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="request.FKIDRequestType === 5" class="col-sm-8 offset-sm-2" style="color: black;">
                            <p>Gentile Cliente,</p>
                            <p>
                                seguendo la procedura indicata nel presente modulo sarà possibile predisporre la pratica
                                <strong>“Credito d'imposta 5.0"</strong>. In particolare, si tratta di
                                un’agevolazione, sotto forma di credito d’imposta, che viene riconosciuta ai progetti
                                di innovazione avviati dal 1 gennaio 2024 e completati entro il 31 dicembre 2025.
                                L’obiettivo è quello di investire in beni materiali e immateriali nuovi strumentali
                                all’esercizio d’impresa (Allegati A e B alla legge 11 dicembre 2016 n. 232), che oltre
                                ad avere caratteristiche tecnologiche, permettano di conseguire anche una riduzione dei
                                consumi energetici.
                            </p>
                            <p>
                                Gli investimenti sopra menzionati sono considerati <strong>trainanti</strong> poiché,
                                grazie alla loro
                                implementazione e al conseguente raggiungimento della riduzione minima dei consumi,
                                consentono l'accesso a ulteriori agevolazioni opzionali. Tali agevolazioni riguardano
                                gli investimenti finalizzati all'autoproduzione o autoconsumo da <strong>fonti
                                rinnovabili</strong> (ad
                                es. impianto fotovoltaico), nonché le spese per la <strong>formazione dei propri
                                dipendenti</strong>
                                orientata all'acquisizione o al consolidamento delle competenze necessarie per la
                                <strong>transizione digitale ed energetica</strong> dei processi produttivi.
                            </p>
                            <p>
                                Attualmente il “Credito d’imposta 5.0” presenta aliquote differenti in base alla
                                percentuale di riduzione dei consumi energetici che si consegue. Si evidenzia che il
                                credito d’imposta spettante è utilizzabile esclusivamente in compensazione nel modello
                                F24 entro la data del 31/12/2025. L’eventuale credito non ancora utilizzato alla data
                                del 31.12.2025 è riportato in avanti ed è utilizzabile in 5 quote annuali di pari
                                importo.
                            </p>
                            <p>
                                L’impresa è tenuta a conservare, per le attività di vigilanza e controllo, tutta la
                                documentazione necessaria all’accertamento della correttezza e veridicità delle
                                dichiarazioni, delle informazioni e dei dati forniti.
                                In particolare, l’impresa dovrà conservare tutta la <u>documentazione necessaria a
                                dimostrare l’effettivo sostenimento dell’investimento</u> (ad es. fatture, documenti di
                                trasporto, e altri documenti relativi all’acquisizione dei beni agevolati. Tutti i
                                documenti menzionati dovranno contenere l’espresso riferimento alle disposizioni
                                normative relative al “Piano Industria 5.0”), <u>la certificazione contabile, la perizia
                                asseverata per quanto concerne l’attestazione dei requisiti 4.0 dei beni interconnessi,
                                le certificazioni ex ante ed ex post dell’ingegnere energetico (Ege/Esco), il verbale di
                                collaudo e l’avvenuta interconnessione</u>.
                            </p>
                            <p>
                                Relativamente all’attività di controllo, il Ministero, insieme al GSE, verifica sia la
                                correttezza formale delle certificazioni rilasciate, sia la corrispondenza del contenuto
                                delle certificazioni medesime alle disposizioni normative, nonché la verifica, in capo
                                ai soggetti abilitati al rilascio delle certificazioni, del possesso dei requisiti
                                previsti dall’articolo 15 del decreto attuativo del 26 luglio 2024 relativo a
                                “Transizione 5.0”, ivi compreso il possesso di idonee coperture assicurative.
                            </p>
                            <p>
                                La informiamo inoltre che il Credito d’imposta 5.0, prevede che l’interconnessione del
                                bene oggetto di investimento sia mantenuta per tutto il periodo di sorveglianza.
                                Attualmente è previsto che il diritto all’utilizzo del Credito d’imposta 5.0 viene meno
                                se i beni vengono ceduti entro il 31 dicembre del quinto anno successivo al
                                completamento del progetto di innovazione, ma anche se nello stesso periodo non viene
                                mantenuto il risparmio energetico ottenuto.
                            </p>
                            <p>
                                Il costo, di nostra spettanza, per la gestione dell’intera pratica "Credito d’imposta
                                5.0”:
                            </p>
                            <p>{{ request.PaymentDetails }}</p>
                            <p>
                                Verrà emessa una fattura di acconto dopo la firma del contratto di consulenza (1ª fase),
                                una seconda fattura al termine della presentazione della ricevuta di avvenuta consegna
                                della “comunicazione intermedia” (2° fase) e una fattura di saldo al termine della
                                rendicontazione (3° fase).
                            </p>
                            <p>
                                Nota bene: Ogni variazione dei dati societari (ad esempio: IBAN, sede legale, quote
                                societarie, ecc.) e ogni variazione relativa all’investimento deve essere
                                tempestivamente comunicata al Ministero/GSE. Sarà vostra cura comunicarci l’eventuale
                                variazione.
                            </p>

                            <div class="text-center m-t-40">
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="request.FKIDRequestType === 7" class="col-sm-8 offset-sm-2 hyper-info" style="color: black;">
                            <p>Gentile Cliente,</p>
                            <p>
                                la presente informativa ha lo scopo di fornirLe le principali indicazioni operative e normative necessarie per la corretta gestione della pratica relativa all’Iperammortamento 4.0, ai sensi della normativa vigente.
                            </p>
                            <p>
                                Per consentire a TEVANPAL di procedere con l’analisi e la gestione della pratica, Le verrà richiesto di caricare sul nostro portale una serie di documenti e informazioni relativi alla società, al legale rappresentante e all’investimento oggetto di agevolazione.
                            </p>
                            <p>
                                <strong>Requisiti generali dell’investimento</strong>
                            </p>
                            <p>
                                I beni oggetto di agevolazione devono:
                            </p>
                            <ul>
                                <li>essere beni strumentali nuovi, non usati, non rigenerati e non oggetto di permuta;</li>
                                <li>essere destinati a strutture produttive ubicate nel territorio dello Stato;</li>
                                <li>rientrare tra quelli previsti dalla normativa 4.0 ed essere idonei all’interconnessione ai sistemi aziendali.</li>
                            </ul>
                            <p>
                                Qualsiasi operazione di sostituzione, cessione o dismissione del bene in violazione dei vincoli temporali previsti dalla normativa relativa al periodo di ammortamento dell’investimento comporta la decadenza del beneficio non ancora fruito e l’eventuale recupero dell’agevolazione da parte dell’Amministrazione finanziaria.
                            </p>
                            <p>
                                <strong>Avvio dell’investimento e documentazione</strong>
                            </p>
                            <p>L’investimento deve essere avviato nel rispetto delle tempistiche previste dalla normativa.</p>
                            <p>In particolare:</p>
                            <ul>
                                <li>i documenti contrattuali e di acquisto devono essere coerenti con l’iter agevolativo;</li>
                                <li>eventuali irregolarità formali o sostanziali nella documentazione possono determinare la revoca totale o parziale del beneficio in sede di controllo.</li>
                            </ul>
                            <p>
                                È responsabilità del Cliente garantire che i documenti caricati siano completi, veritieri e coerenti con l’investimento realizzato.
                            </p>
                            <p><strong>Aspetti tecnici e condizioni essenziali</strong></p>
                            <p>Per i beni agevolati è necessario che:</p>
                            <ul>
                                <li>siano rispettati i requisiti tecnici 4.0, inclusa l’effettiva interconnessione;</li>
                                <li>siano rispettate le norme in materia di sicurezza sul lavoro e la regolarità contributiva (DURC);</li>
                                <li>la documentazione tecnica e fiscale sia correttamente predisposta e conservata.</li>
                            </ul>
                            <p>
                                La mancata osservanza anche di uno solo dei requisiti richiesti dalla normativa comporta la perdita del diritto all’agevolazione.
                            </p>
                            <p><strong>Corrispettivi professionali</strong></p>
                            <p>
                                I costi per la gestione della pratica saranno determinati in base al valore complessivo dell’investimento e secondo quanto indicato nel contratto di consulenza che verrà generato successivamente nella Piattaforma Tevanpal.
                            </p>
                            <p>È prevista:</p>
                            <ul>
                                <li>una fattura di acconto alla sottoscrizione dell’incarico (prima fase);</li>
                                <li>una fattura di saldo al completamento della rendicontazione (seconda fase).</li>
                            </ul>
                            <p><strong>Obbligo di comunicazione delle variazioni</strong></p>
                            <p>
                                Ogni variazione dei dati societari rilevanti (a titolo esemplificativo: IBAN, sede legale, assetto societario, rappresentanza legale) deve essere tempestivamente comunicata a TEVANPAL, al fine di consentire i necessari aggiornamenti verso gli enti competenti.
                            </p>
                            <p>
                                Il costo per la gestione dell'intera pratica relativa all'"Iperammortamento 4.0" è riportato di seguito:
                            </p>
                            <p *ngIf="request.PaymentDetails !== null && request.PaymentDetails !== ''">{{ request.PaymentDetails }}</p>
                            <p *ngIf="request.PaymentDetails === null || request.PaymentDetails === ''">
                                il costo è pari a {{ request.PaymentCost2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (più oneri di legge) divisi in {{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (1° parte) e {{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di {{ (request.PaymentCost2 / 2) * 1.22 | currency:'EUR':'':'1.2-2':'it-IT' }} euro ({{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento Consulenza "Iperammortamento 4.0" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.
                            </p>

                            <div style="text-align: center;">
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[0]">
                                    Dichiaro di aver letto e compreso l’informativa
                                </mat-checkbox>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="submit"
                                        [disabled]="!checkboxRelease[0]"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 1 && request.FKIDRequestType === 6 && hyperDepreciationStep" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                         <div class="col-sm-8 offset-sm-2 hyper-info" style="color: black;">
                            <p>Gentile Cliente,</p>
                            <p>
                                la presente informativa ha lo scopo di fornirLe le principali indicazioni operative e normative necessarie per la corretta gestione della pratica relativa all’Iperammortamento 4.0, ai sensi della normativa vigente.
                            </p>
                            <p>
                                Per consentire a TEVANPAL di procedere con l’analisi e la gestione della pratica, Le verrà richiesto di caricare sul nostro portale una serie di documenti e informazioni relativi alla società, al legale rappresentante e all’investimento oggetto di agevolazione.
                            </p>
                            <p><strong>Requisiti generali dell’investimento</strong></p>
                            <p>I beni oggetto di agevolazione devono:</p>
                            <ul>
                                <li>essere beni strumentali nuovi, non usati, non rigenerati e non oggetto di permuta;</li>
                                <li>essere destinati a strutture produttive ubicate nel territorio dello Stato;</li>
                                <li>rientrare tra quelli previsti dalla normativa 4.0 ed essere idonei all’interconnessione ai sistemi aziendali.</li>
                            </ul>
                            <p>
                                Qualsiasi operazione di sostituzione, cessione o dismissione del bene in violazione dei vincoli temporali previsti dalla normativa relativa al periodo di ammortamento dell’investimento comporta la decadenza del beneficio non ancora fruito e l’eventuale recupero dell’agevolazione da parte dell’Amministrazione finanziaria.
                            </p>
                            <p><strong>Avvio dell’investimento e documentazione</strong></p>
                            <p>L’investimento deve essere avviato nel rispetto delle tempistiche previste dalla normativa.</p>
                            <p>In particolare:</p>
                            <ul>
                                <li>i documenti contrattuali e di acquisto devono essere coerenti con l’iter agevolativo;</li>
                                <li>eventuali irregolarità formali o sostanziali nella documentazione possono determinare la revoca totale o parziale del beneficio in sede di controllo.</li>
                            </ul>
                            <p>
                                È responsabilità del Cliente garantire che i documenti caricati siano completi, veritieri e coerenti con l’investimento realizzato.
                            </p>
                            <p><strong>Aspetti tecnici e condizioni essenziali</strong></p>
                            <p>Per i beni agevolati è necessario che:</p>
                            <ul>
                                <li>siano rispettati i requisiti tecnici 4.0, inclusa l’effettiva interconnessione;</li>
                                <li>siano rispettate le norme in materia di sicurezza sul lavoro e la regolarità contributiva (DURC);</li>
                                <li>la documentazione tecnica e fiscale sia correttamente predisposta e conservata.</li>
                            </ul>
                            <p>
                                La mancata osservanza anche di uno solo dei requisiti richiesti dalla normativa comporta la perdita del diritto all’agevolazione.
                            </p>
                            <p><strong>Corrispettivi professionali</strong></p>
                            <p>
                                I costi per la gestione della pratica saranno determinati in base al valore complessivo dell’investimento e secondo quanto indicato nel contratto di consulenza che verrà generato successivamente nella Piattaforma Tevanpal.
                            </p>
                            <p>È prevista:</p>
                            <ul>
                                <li>una fattura di acconto alla sottoscrizione dell’incarico (prima fase);</li>
                                <li>una fattura di saldo al completamento della rendicontazione (seconda fase).</li>
                            </ul>
                            <p><strong>Obbligo di comunicazione delle variazioni</strong></p>
                            <p>
                                Ogni variazione dei dati societari rilevanti (a titolo esemplificativo: IBAN, sede legale, assetto societario, rappresentanza legale) deve essere tempestivamente comunicata a TEVANPAL, al fine di consentire i necessari aggiornamenti verso gli enti competenti.
                            </p>
                            <p>
                                Il costo per la gestione dell'intera pratica relativa all'"Iperammortamento 4.0" è riportato di seguito:
                            </p>
                            <p *ngIf="request.PaymentDetails !== null && request.PaymentDetails !== ''">{{ request.PaymentDetails }}</p>
                            <p *ngIf="request.PaymentDetails === null || request.PaymentDetails === ''">
                                il costo è pari a {{ request.PaymentCost2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (più oneri di legge) divisi in {{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (1° parte) e {{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro (2° parte). A tal proposito nella Piattaforma Tevanpal dovrete caricare la distinta di pagamento di {{ (request.PaymentCost2 / 2) * 1.22 | currency:'EUR':'':'1.2-2':'it-IT' }} euro ({{ request.PaymentCost2 / 2 | currency:'EUR':'':'1.2-2':'it-IT' }} euro + Iva) da effettuare al seguente IBAN: IT52K0200884811000107239177 con i seguenti riferimenti: Causale: Pagamento Consulenza "Iperammortamento 4.0" prima fase ; Intestazione: Tevanpal Consult Srl Unipersonale.
                            </p>

                            <div style="text-align: center;">
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[2]">
                                    Dichiaro di aver letto e compreso l’informativa
                                </mat-checkbox>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="submit"
                                        [disabled]="!checkboxRelease[2]"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 2 && !request.Simplified" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <div *ngIf="request.FKIDRequestType === 5" class="row m-b-10">
                                <div class="col-md-12 text-center">
                                    <p class="text-center">Prima di compilare i campi ti consigliamo di vedere le seguenti video pillole informative.</p>
                                    <button class="btn btn-embossed btn-success" style="margin-bottom: 10px !important;" (click)="openVideoModal(9)">
                                        <i class="fa fa-video-camera"></i>Video Pillola Informativa 1
                                    </button>
                                    <button class="btn btn-embossed btn-success" style="margin-bottom: 10px !important;" (click)="openVideoModal(10)">
                                        <i class="fa fa-video-camera"></i>Video Pillola Informativa 2
                                    </button>
                                    <button class="btn btn-embossed btn-success" style="margin-bottom: 10px !important;" (click)="openVideoModal(1)">
                                        <i class="fa fa-video-camera"></i>Video Pillola Informativa 3
                                    </button>
                                </div>
                            </div>

                            <form #step2Form="ngForm" role="form" class="form-horizontal form-validation">
                                <p class="section-customer-data">Dati relativi alla Società / Ditta Individuale</p>
                                <div class="form-group">
                                    <label for="company-name" class="col-sm-3 control-label">Ragione Sociale
                                        Società / Ditta individuale</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="company-name"
                                               name="company-name"
                                               class="form-control"
                                               placeholder="Inserisci ragione sociale della società / ditta individuale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(companyName.valid || companyName.pristine),
                                                'form-success': companyName.valid
                                           }"
                                               [(ngModel)]="customer.CompanyName"
                                               #companyName="ngModel">
                                        <i class="icon-drawer"></i>
                                        <div [hidden]="companyName.valid || companyName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="vat" class="col-sm-3 control-label">Partita IVA</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="vat"
                                               name="vat"
                                               class="form-control"
                                               placeholder="Inserisci partita IVA"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(vat.valid || vat.pristine),
                                                'form-success': vat.valid
                                           }"
                                               [(ngModel)]="customer.VATNumber"
                                               #vat="ngModel">
                                        <i class="icon-list"></i>
                                        <div [hidden]="vat.valid || vat.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="head-office" class="col-sm-3 control-label">Sede Legale Società / Ditta
                                        Individuale (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="head-office"
                                               name="head-office"
                                               class="form-control"
                                               placeholder="Inserisci comune della sede legale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(headOffice.valid || headOffice.pristine),
                                                'form-success': headOffice.valid
                                           }"
                                               [(ngModel)]="customer.HeadOffice"
                                               #headOffice="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="headOffice.valid || headOffice.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="head-office-province"
                                               name="head-office-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(headOfficeProvince.valid || headOfficeProvince.pristine),
                                                'form-success': headOfficeProvince.valid
                                           }"
                                               [(ngModel)]="customer.HeadOfficeProvince"
                                               #headOfficeProvince="ngModel">
                                        <div [hidden]="headOfficeProvince.valid || headOfficeProvince.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label">Via e Civico Sede Legale</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="address"
                                               name="address"
                                               class="form-control"
                                               placeholder="Inserisci via della sede legale"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(address.valid || address.pristine),
                                                'form-success': address.valid
                                           }"
                                               [(ngModel)]="customer.Address"
                                               #address="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="address.valid || address.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="house-number"
                                               name="house-number"
                                               class="form-control"
                                               placeholder="Civico"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(houseNumber.valid || houseNumber.pristine),
                                                'form-success': houseNumber.valid
                                           }"
                                               [(ngModel)]="customer.HouseNumber"
                                               #houseNumber="ngModel">
                                        <div [hidden]="houseNumber.valid || houseNumber.pristine"
                                             class="form-error valid">
                                            Campo richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="iban" class="col-sm-3 control-label">IBAN</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="iban"
                                               name="iban"
                                               class="form-control"
                                               placeholder="Inserisci IBAN (27 caratteri)"
                                               minlength="27"
                                               maxlength="27"
                                               required
                                               autocomplete="off"
                                               (paste)="onPasteIBAN($event)"
                                               [ngClass]="{
                                                'form-error': !(iban.valid || iban.pristine),
                                                'form-success': iban.valid
                                           }"
                                               (ngModelChange)="onChangeIBAN($event)"
                                               [ngModel]="customer.IBAN"
                                               #iban="ngModel">
                                        <i class="icon-credit-card"></i>
                                        <div [hidden]="iban.valid || iban.pristine"
                                             class="form-error valid">
                                            Inserisci esattamente 27 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="support-bank-name" class="col-sm-3 control-label">Nome della Banca di
                                        appoggio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="support-bank-name"
                                               name="support-bank-name"
                                               class="form-control"
                                               placeholder="Inserisci nome della banca di appoggio"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(supportBankName.valid || supportBankName.pristine),
                                                'form-success': supportBankName.valid
                                           }"
                                               [(ngModel)]="customer.SupportBankName"
                                               #supportBankName="ngModel">
                                        <i class="icon-wallet"></i>
                                        <div [hidden]="supportBankName.valid || supportBankName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group">
                                    <label for="support-bank-bic" class="col-sm-3 control-label">BIC della Banca di
                                        appoggio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="support-bank-bic"
                                               name="support-bank-bic"
                                               class="form-control"
                                               placeholder="Inserisci BIC della banca di appoggio (8 o 11 caratteri)"
                                               minlength="8"
                                               maxlength="11"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(supportBankBIC.valid || supportBankBIC.pristine),
                                                'form-success': supportBankBIC.valid
                                           }"
                                               [(ngModel)]="customer.SupportBankBIC"
                                               #supportBankBIC="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="supportBankBIC.valid || supportBankBIC.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 8 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="sdi-code" class="col-sm-3 control-label">Codice SDI</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="sdi-code"
                                               name="sdi-code"
                                               class="form-control"
                                               placeholder="Inserisci codice SDI (7 caratteri)"
                                               minlength="7"
                                               maxlength="7"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(sdiCode.valid || sdiCode.pristine),
                                                'form-success': sdiCode.valid
                                           }"
                                               [(ngModel)]="customer.SDICode"
                                               #sdiCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="sdiCode.valid || sdiCode.pristine"
                                             class="form-error valid">
                                            Inserisci esattamente 7 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="ula-last-balance" class="col-sm-3 control-label">ULA Ultimo Bilancio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="ula-last-balance"
                                               name="ula-last-balance"
                                               class="form-control"
                                               placeholder="Inserisci ULA relative all'ultimo bilancio approvato"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(ulaLastBalance.valid || ulaLastBalance.pristine),
                                                'form-success': ulaLastBalance.valid
                                           }"
                                               [(ngModel)]="customer.ULALastBalance"
                                               #ulaLastBalance="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Unità lavorative anno, ovvero il numero medio di dipendenti occupati
                                            nell'impresa relativamente all'ultimo Bilancio/Modello Unico depositato.
                                        </div>
                                        <div [hidden]="ulaLastBalance.valid || ulaLastBalance.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">Numero di Telefono Fisso</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="phone"
                                               name="phone"
                                               class="form-control"
                                               placeholder="Inserisci numero di telefono fisso"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(phone.valid || phone.pristine),
                                                'form-success': phone.valid
                                           }"
                                               [(ngModel)]="customer.Phone"
                                               #phone="ngModel">
                                        <i class="icon-call-end"></i>
                                        <div [hidden]="phone.valid || phone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="mobile-phone" class="col-sm-3 control-label">Numero di Telefono
                                        Cellulare</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="mobile-phone"
                                               name="mobile-phone"
                                               class="form-control"
                                               placeholder="Inserisci numero di telefono cellulare"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(mobilePhone.valid || mobilePhone.pristine),
                                                'form-success': mobilePhone.valid
                                           }"
                                               [(ngModel)]="customer.MobilePhone"
                                               #mobilePhone="ngModel">
                                        <i class="icon-screen-smartphone"></i>
                                        <div [hidden]="mobilePhone.valid || mobilePhone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <p class="section-customer-data" style="margin-top: 40px;">Dati del Legale
                                    Rappresentante per la compilazione del Contratto di Consulenza</p>

                                <div class="form-group">
                                    <label for="name" class="col-sm-3 control-label">Nome Legale Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="name"
                                               name="name"
                                               class="form-control"
                                               placeholder="Inserisci nome del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(name.valid || name.pristine),
                                                'form-success': name.valid
                                           }"
                                               [(ngModel)]="customer.Name"
                                               #name="ngModel">
                                        <i class="icon-user"></i>
                                        <div [hidden]="name.valid || name.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="surname" class="col-sm-3 control-label">Cognome Legale
                                        Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="surname"
                                               name="surname"
                                               class="form-control"
                                               placeholder="Inserisci cognome del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(surname.valid || surname.pristine),
                                                'form-success': surname.valid
                                           }"
                                               [(ngModel)]="customer.Surname"
                                               #surname="ngModel">
                                        <i class="icon-user"></i>
                                        <div [hidden]="surname.valid || surname.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="birth-place" class="col-sm-3 control-label">Luogo di Nascita Legale
                                        Rappresentante (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="birth-place"
                                               name="birth-place"
                                               class="form-control"
                                               class="form-control"
                                               placeholder="Inserisci comune del luogo di nascita del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthPlace.valid || birthPlace.pristine),
                                                'form-success': birthPlace.valid
                                           }"
                                               [(ngModel)]="customer.BirthPlace"
                                               #birthPlace="ngModel">
                                        <i class="icon-pin"></i>
                                        <div [hidden]="name.valid || name.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="birth-place-province"
                                               name="birth-place-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthPlaceProvince.valid || birthPlaceProvince.pristine),
                                                'form-success': birthPlaceProvince.valid
                                           }"
                                               [(ngModel)]="customer.BirthPlaceProvince"
                                               #birthPlaceProvince="ngModel">
                                        <div [hidden]="birthPlaceProvince.valid || birthPlaceProvince.pristine"
                                             class="form-error valid">
                                            Inserire almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data di Nascita Legale
                                        Rappresentante</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="birth-date"
                                               name="birth-date"
                                               class="form-control"
                                               placeholder="Inserisci data di nascita del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(birthDate.valid || birthDate.pristine),
                                                'form-success': birthDate.valid
                                           }"
                                               [(ngModel)]="birthDateString"
                                               #birthDate="ngModel">
                                        <i class="icon-calendar"></i>
                                        <div [hidden]="birthDate.valid || birthDate.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="city" class="col-sm-3 control-label">Residenza Legale
                                        Rappresentante (Comune e Provincia)</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="city"
                                               name="city"
                                               class="form-control"
                                               placeholder="Inserisci comune di residenza del legale rappresentante"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(city.valid || city.pristine),
                                                'form-success': city.valid
                                           }"
                                               [(ngModel)]="customer.City"
                                               #city="ngModel">
                                        <i class="icon-pin"></i>
                                        <div [hidden]="city.valid || city.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="province"
                                               name="province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(province.valid || province.pristine),
                                                'form-success': province.valid
                                           }"
                                               [(ngModel)]="customer.Province"
                                               #province="ngModel">
                                        <div [hidden]="province.valid || province.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="getMissingFieldsStep2().length > 0"
                                     class="alert alert-danger text-left m-t-30">
                                    <strong>Devi ancora compilare i seguenti campi:</strong>
                                    <ul style="margin-bottom: 0; padding-left: 20px;">
                                        <li *ngFor="let field of getMissingFieldsStep2()">
                                            {{ field }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-default"
                                            (click)="goStepBackward()">
                                        <i class="fa fa-arrow-left"></i>Indietro
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-primary"
                                            (click)="goStepForward(step2Form)"
                                            [disabled]="!canAdvanceFromCurrentStep(step2Form)">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 3" class="row" id="step3"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <form #step3Form="ngForm" role="form"
                                  class="form-horizontal form-validation">
                                <p class="section-customer-data">Dati relativi all'Investimento</p>
                                <div *ngIf="request.CompanyParticipation || request.PartnersParticipation"
                                     class="alert alert-warning" role="alert">
                                    <i class="fa fa-warning"></i> Gentile cliente, a seguito della possibile relazione
                                    di collegamento o associazione
                                    tra la vostra e altre imprese, sarete contattati da un nostro consulente per un
                                    approfondimento sulla vostra pratica.
                                </div>

                                <div class="form-group m-b-15">
                                    <label class="col-12 control-label">
                                        La società partecipa e/o è partecipata da altre società per quote pari o
                                        superiori al 25% (società collegata/associata)?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="company-participation"
                                                         name="company-participation"
                                                         required
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.CompanyParticipation">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div class="text-center">
                                    <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(4)">
                                        <i class="fa fa-video-camera"></i>Pillola Informativa
                                    </button>
                                </div>

                                <div class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        I soci partecipano, anche di concerto, in altre società?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="partners-participation"
                                                         name="partners-participation"
                                                         required
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.PartnersParticipation">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Si è scelto di procedere con l'investimento tramite:
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="investment-mode"
                                                         name="investment-mode"
                                                         required
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.InvestmentMode">
                                            <mat-radio-button
                                                    *ngFor="let radioInvestmentModeOption of radioInvestmentModeOptions"
                                                    [value]="radioInvestmentModeOption">
                                                <span style="font-weight: 400 !important;">{{ radioInvestmentModeOption }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.InvestmentMode !== 'Fondi Propri'" class="form-group">
                                    <label for="leasing-company-name" class="col-sm-3 control-label">Nome Società di
                                        Leasing Finanziatrice</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="leasing-company-name"
                                               name="leasing-company-name"
                                               class="form-control"
                                               placeholder="Inserisci nome della società di leasing finanziatrice"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(leasingCompanyName.valid || leasingCompanyName.pristine),
                                                'form-success': leasingCompanyName.valid
                                           }"
                                               [(ngModel)]="request.LeasingCompanyName"
                                               #leasingCompanyName="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="leasingCompanyName.valid || leasingCompanyName.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>


                                <div *ngIf="request.InvestmentMode !== 'Fondi Propri'" class="form-group m-b-30">
                                    <label class="col-sm-3 control-label">
                                        Durata Leasing / Finanziamento:
                                    </label>
                                    <div class="col-sm-9">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>Seleziona durata</mat-label>
                                            <mat-select id="investment-duration"
                                                       name="investment-duration"
                                                       required
                                                       [(ngModel)]="request.InvestmentDuration">
                                                <mat-option *ngFor="let radioInvestmentDurationOption of radioInvestmentDurationOptions"
                                                           [value]="radioInvestmentDurationOption">
                                                    {{ radioInvestmentDurationOption }} anni
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="operational-headquarters" class="col-sm-3 control-label">
                                        Comune Sede Operativa (Unità locale di destinazione beni oggetto
                                        dell'investimento):
                                    </label>
                                    <div class="col-sm-7 prepend-icon m-t-10">
                                        <input type="text"
                                               id="operational-headquarters"
                                               name="operational-headquarters"
                                               class="form-control"
                                               placeholder="Inserisci sede operativa"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquarters.valid || operationalHeadquarters.pristine),
                                                'form-success': operationalHeadquarters.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquarters"
                                               #operationalHeadquarters="ngModel">
                                        <i class="icon-home"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Si indichi un’unità operativa che compare nella visura camerale. Se la sede
                                            operativa oggetto dell’investimento coincide con la sede legale, indicare
                                            quest’ultima.
                                        </div>
                                        <div [hidden]="operationalHeadquarters.valid || operationalHeadquarters.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2 m-t-10">
                                        <input type="text"
                                               id="operational-headquarters-province"
                                               name="operational-headquarters-province"
                                               class="form-control"
                                               placeholder="Provincia"
                                               minlength="2"
                                               maxlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersProvince.valid || operationalHeadquartersProvince.pristine),
                                                'form-success': operationalHeadquartersProvince.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersProvince"
                                               #operationalHeadquartersProvince="ngModel">
                                        <div [hidden]="operationalHeadquartersProvince.valid || operationalHeadquartersProvince.pristine"
                                             class="form-error valid">
                                            Inserire esattamente 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="operational-headquarters-address" class="col-sm-3 control-label">Via e
                                        Civico Sede Operativa</label>
                                    <div class="col-sm-7 prepend-icon">
                                        <input type="text"
                                               id="operational-headquarters-address"
                                               name="operational-headquarters-address"
                                               class="form-control"
                                               placeholder="Inserisci via della sede operativa"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersAddress.valid || operationalHeadquartersAddress.pristine),
                                                'form-success': operationalHeadquartersAddress.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersAddress"
                                               #operationalHeadquartersAddress="ngModel">
                                        <i class="icon-home"></i>
                                        <div [hidden]="operationalHeadquartersAddress.valid || operationalHeadquartersAddress.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <input type="text"
                                               id="operational-headquarters-house-number"
                                               name="operational-headquarters-house-number"
                                               class="form-control"
                                               placeholder="Civico"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(operationalHeadquartersHouseNumber.valid || operationalHeadquartersHouseNumber.pristine),
                                                'form-success': operationalHeadquartersHouseNumber.valid
                                           }"
                                               [(ngModel)]="request.OperationalHeadquartersHouseNumber"
                                               #operationalHeadquartersHouseNumber="ngModel">
                                        <div [hidden]="operationalHeadquartersHouseNumber.valid || operationalHeadquartersHouseNumber.pristine"
                                             class="form-error valid">
                                            Campo richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label class="col-12">Indicare i dati catastali dell'unità operativa/struttura
                                        produttiva/capannone industriale dove si intende fare l’investimento.</label>
                                    <label for="cadastral-code" class="col-sm-3 control-label">Codice catastale</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="cadastral-code"
                                               name="cadastral-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice catastale"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(cadastralCode.valid || cadastralCode.pristine),
                                                'form-success': cadastralCode.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralCode"
                                               #cadastralCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="cadastralCode.valid || cadastralCode.pristine"
                                             class="form-error valid">
                                            Il codice catastale è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-section" class="col-sm-3 control-label">Sezione</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-section"
                                               name="tax-credit-5-section"
                                               class="form-control"
                                               placeholder="Inserisci la sezione dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Section.valid || taxCredit5Section.pristine),
                                                'form-success': taxCredit5Section.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSection"
                                               #taxCredit5Section="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Se non presente, indicare NP.
                                        </div>
                                        <div [hidden]="taxCredit5Section.valid || taxCredit5Section.pristine"
                                             class="form-error valid">
                                            La sezione dei dati catastali è richiesta.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-sheet" class="col-sm-3 control-label">Foglio</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-sheet"
                                               name="tax-credit-5-sheet"
                                               class="form-control"
                                               placeholder="Inserisci il foglio dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Sheet.valid || taxCredit5Sheet.pristine),
                                                'form-success': taxCredit5Sheet.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSheet"
                                               #taxCredit5Sheet="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Sheet.valid || taxCredit5Sheet.pristine"
                                             class="form-error valid">
                                            Il foglio dei dati catastali è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-particle" class="col-sm-3 control-label">Particella prevalente</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-particle"
                                               name="tax-credit-5-particle"
                                               class="form-control"
                                               placeholder="Inserisci la particella dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Particle.valid || taxCredit5Particle.pristine),
                                                'form-success': taxCredit5Particle.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralParticle"
                                               #taxCredit5Particle="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit5Particle.valid || taxCredit5Particle.pristine"
                                             class="form-error valid">
                                            La particella prevalente dei dati catastali è richiesta.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-sub" class="col-sm-3 control-label">Sub prevalente</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-sub"
                                               name="tax-credit-5-sub"
                                               class="form-control"
                                               placeholder="Inserisci il dato sub dei dati catastali"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5Sub.valid || taxCredit5Sub.pristine),
                                                'form-success': taxCredit5Sub.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5CadastralSub"
                                               #taxCredit5Sub="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Se non presente, indicare NP.
                                        </div>
                                        <div [hidden]="taxCredit5Sub.valid || taxCredit5Sub.pristine"
                                             class="form-error valid">
                                            Il dato sub prevalente dei dati catastali è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5"
                                     class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il bene oggetto di agevolazione rientra nella categoria:
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[0]"
                                                      (change)="valueChangeInvestmentType(0)">
                                            {{ checkboxInvestmentTypeOptions[0] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[1]"
                                                      (change)="valueChangeInvestmentType(1)">
                                            {{ checkboxInvestmentTypeOptions[1] }}
                                        </mat-checkbox>
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox"
                                                      [checked]="checkboxInvestmentTypeValues[2]"
                                                      (change)="valueChangeInvestmentType(2)">
                                            {{ checkboxInvestmentTypeOptions[2] }}
                                        </mat-checkbox>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="investment-amount" class="col-sm-3 control-label">
                                        Importo totale dell'investimento (al netto dell'IVA)
                                    </label>
                                    <div class="col-sm-9 prepend-icon investment-amount-wrap m-t-10">
                                        <input type="text"
                                               id="investment-amount"
                                               name="investment-amount"
                                               class="form-control"
                                               placeholder="Inserisci l'importo totale dell'investimento"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(investmentAmount.valid || investmentAmount.pristine),
                                                'form-success': investmentAmount.valid
                                           }"
                                               [(ngModel)]="investmentAmountDisplay"
                                               (keydown)="onInvestmentAmountKeyDown($event)"
                                               (input)="onInvestmentAmountInput($event)"
                                               (blur)="onInvestmentAmountBlur()"
                                               #investmentAmount="ngModel">
                                        <i class="icon-wallet"></i>
                                        <span class="euro-prefix" aria-hidden="true">€</span>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Le migliaia sono separate automaticamente; usare punto o virgola per i centesimi (fino a 2 cifre).
                                        </div>
                                        <div [hidden]="investmentAmount.valid || investmentAmount.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label class="col-sm-3 control-label">
                                        Aliquota di ammortamento
                                    </label>
                                    <div class="col-sm-9 m-t-10">
                                        <mat-checkbox color="primary"
                                                      class="release-checkbox checkbox-multiple-depreciation"
                                                      [ngModel]="multipleDepreciationRates"
                                                      [ngModelOptions]="{ standalone: true }"
                                                      (ngModelChange)="onMultipleDepreciationRatesChange($event)">
                                            Più beni con aliquote di ammortamento diverse
                                        </mat-checkbox>
                                    </div>
                                </div>

                                <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !multipleDepreciationRates"
                                     class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9 prepend-icon percent-suffix-wrap m-t-10">
                                        <input type="number"
                                               id="depreciation-rate"
                                               class="form-control"
                                               placeholder="Inserisci l'aliquota di ammortamento"
                                               step="any"
                                               min="0"
                                               max="100"
                                               autocomplete="off"
                                               (wheel)="$event.preventDefault()"
                                               [ngModelOptions]="{ standalone: true }"
                                               [ngClass]="{
                                                'form-error': !(depreciationRate.valid || depreciationRate.pristine),
                                                'form-success': depreciationRate.valid
                                           }"
                                               [(ngModel)]="request.DepreciationRate"
                                               #depreciationRate="ngModel">
                                        <i class="icon-wallet"></i>
                                        <span class="percent-suffix">%</span>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Consultare il vostro commercialista/consulente fiscale per individuare l'aliquota di ammortamento del/i bene/beni oggetto di investimento
                                        </div>
                                        <div [hidden]="depreciationRate.valid || depreciationRate.pristine"
                                             class="form-error valid">
                                            Il campo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && multipleDepreciationRates"
                                     class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9 m-t-10">
                                        <div class="depreciation-assets-list">
                                            <div *ngFor="let asset of request.DepreciationAssets; let i = index"
                                                 class="depreciation-asset-row">
                                                <input type="text"
                                                       class="form-control depreciation-asset-description"
                                                       placeholder="Descrizione del bene"
                                                       autocomplete="off"
                                                       [ngModelOptions]="{ standalone: true }"
                                                       [(ngModel)]="asset.description">
                                                <div class="depreciation-rate-wrap">
                                                    <input type="number"
                                                           class="form-control depreciation-asset-rate"
                                                           placeholder="Aliquota"
                                                           step="any"
                                                           min="0"
                                                           max="100"
                                                           autocomplete="off"
                                                           (wheel)="$event.preventDefault()"
                                                           [ngModelOptions]="{ standalone: true }"
                                                           [(ngModel)]="asset.rate">
                                                    <span class="percent-suffix">%</span>
                                                </div>
                                                <button *ngIf="request.DepreciationAssets!.length > 2"
                                                        type="button"
                                                        class="depreciation-asset-delete-btn"
                                                        aria-label="Rimuovi bene"
                                                        (click)="removeDepreciationAsset(i)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                            <button type="button"
                                                    class="btn btn-sm btn-default btn-embossed m-t-10"
                                                    (click)="addDepreciationAsset()">
                                                + Aggiungi bene
                                            </button>
                                        </div>
                                        <div class="info-box m-t-10">
                                            <i class="fa fa-info-circle"></i>
                                            Consultare il vostro commercialista/consulente fiscale per individuare l'aliquota di ammortamento del/i bene/beni oggetto di investimento
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        L'investimento programmato a quale attività lavorativa si riferisce? (Indicare
                                        il Codice ATECO)
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="text"
                                               id="ateco-code"
                                               name="ateco-code"
                                               class="form-control"
                                               placeholder="Inserisci il codice ATECO"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(atecoCode.valid || atecoCode.pristine),
                                                'form-success': atecoCode.valid
                                           }"
                                               [(ngModel)]="request.AtecoCode"
                                               #atecoCode="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="atecoCode.valid || atecoCode.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-30">
                                    <label *ngIf="request.FKIDRequestType !== 2" class="col-12 control-label">
                                        L'investimento sarà oggetto di altre agevolazioni?
                                    </label>
                                    <label *ngIf="request.FKIDRequestType === 2" class="col-12 control-label">
                                        L'investimento sarà oggetto di altre agevolazioni, oltre al Credito d’imposta
                                        4.0?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="concessions"
                                                         name="concessions"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.Concessions">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.Concessions" class="form-group">
                                    <label for="concessions-details" class="col-sm-3 control-label">
                                        Indicare quali (ad esempio Bandi nazionali, regionali, locali, ecc.)
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="text"
                                               id="concessions-details"
                                               name="concessions-details"
                                               class="form-control"
                                               placeholder="Indicare di quali agevolazioni sarà oggetto l'investimento"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(concessionsDetails.valid || concessionsDetails.pristine),
                                                'form-success': concessionsDetails.valid
                                           }"
                                               [(ngModel)]="request.ConcessionsDetails"
                                               #concessionsDetails="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="concessionsDetails.valid || concessionsDetails.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <!-- Parte 4.0 -->
                                <div *ngIf="request.FKIDRequestType === 2 || request.FKIDRequestType === 4" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il credito d'imposta 4.0, attualmente pari al 20% dell'importo
                                        dell'investimento, si può compensare in 3 anni dalla data di interconnessione
                                        del bene. Decidete di procedere con la compensazione in 3 anni (2025-2026-2027)?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-4-years"
                                                         name="tax-credit-4-years"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit4Years">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="(request.FKIDRequestType === 2 || request.FKIDRequestType === 4) && (request.TaxCredit4Years === false)"
                                     class="form-group">
                                    <label for="support-bank-bic" class="col-sm-3 control-label">Indica gli anni in cui
                                        andrai a compensare il relativo credito d’imposta 4.0</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="number"
                                               id="tax-credit-4-years-compensation"
                                               name="tax-credit-4-years-compensation"
                                               class="form-control"
                                               placeholder="Inserisci gli anni"
                                               min="0"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4YearsCompensation.valid || taxCredit4YearsCompensation.pristine),
                                                'form-success': taxCredit4YearsCompensation.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4YearsCompensation"
                                               #taxCredit4YearsCompensation="ngModel">
                                        <i class="icon-info"></i>
                                        <div [hidden]="taxCredit4YearsCompensation.valid || taxCredit4YearsCompensation.pristine"
                                             class="form-error valid">
                                            Inserisci un numero.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 2 || request.FKIDRequestType === 4" class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data presunta di avvio
                                        dell'investimento</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-4-start-date"
                                               name="tax-credit-4-start-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di avvio dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4StartDate.valid || taxCredit4StartDate.pristine),
                                                'form-success': taxCredit4StartDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4StartDate"
                                               #taxCredit4StartDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 2 || request.FKIDRequestType === 4" class="form-group">
                                    <label for="birth-date" class="col-sm-3 control-label">Data presunta di conclusione
                                        dell'investimento (data stimata di consegna del bene)</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-4-end-date"
                                               name="tax-credit-4-end-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di conclusione dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit4EndDate.valid || taxCredit4EndDate.pristine),
                                                'form-success': taxCredit4EndDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit4EndDate"
                                               #taxCredit4EndDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <!-- DNS + IP 4.0 -->
                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società/ditta individuale rispetta le normative sulla sicurezza nei luoghi di
                                        lavoro applicabili in ciascun settore e gli obblighi di versamento dei
                                        contributi previdenziali e assistenziali a favore dei lavoratori?
                                    </label>
                                    <div *ngIf="false" class="text-center m-b-10">
                                        <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(3)">
                                            <i class="fa fa-video-camera"></i>Pillola Informativa
                                        </button>
                                    </div>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-regulations"
                                                         name="tax-credit-5-regulations"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Regulations">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società/ditta individuale è un'impresa destinataria di sanzioni interdittive
                                        ai sensi del decreto legislativo 8 giugno 2001, n. 231 e ai sensi del codice
                                        antimafia di cui al decreto legislativo 6 settembre 2011, n. 159?
                                    </label>
                                    <div class="text-center m-b-10">
                                        <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(11)">
                                            <i class="fa fa-video-camera"></i>Pillola Informativa
                                        </button>
                                    </div>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-sanctions"
                                                         name="tax-credit-5-sanctions"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Sanctions">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group">
                                    <div class="col-sm-3">
                                        <label for="tax-credit-5-beneficial-owner" class="control-label m-b-10">
                                            Chi è il Titolare Effettivo?
                                        </label>
                                        <div class="m-l-10 m-b-10">
                                            <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(2)">
                                                <i class="fa fa-video-camera"></i>Pillola Informativa
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="text"
                                               id="tax-credit-5-beneficial-owner"
                                               name="tax-credit-5-beneficial-owner"
                                               class="form-control"
                                               placeholder="Inserisci il titolare effettivo"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(beneficialOwner.valid || beneficialOwner.pristine),
                                                'form-success': beneficialOwner.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5BeneficialOwner"
                                               #beneficialOwner="ngModel">
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            In caso di più titolari effettivi, scrivere Nome e Cognome separato da punto
                                            e virgola
                                        </div>
                                        <i class="icon-info"></i>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Secondo la normativa antiriciclaggio per titolari effettivi si intendono le
                                            persone fisiche che, in ultima istanza, possiedono o controllano un’entità
                                            giuridica ovvero ne risultano i beneficiari.
                                        </div>
                                        <div [hidden]="beneficialOwner.valid || beneficialOwner.pristine"
                                             class="form-error valid">
                                            Il titolare effettivo è richiesto.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La Società ha già un revisore legale dei conti?
                                    </label>
                                    <div *ngIf="false" class="text-center m-b-10">
                                        <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(12)">
                                            <i class="fa fa-video-camera"></i>Pillola Informativa
                                        </button>
                                    </div>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-revisor"
                                                         name="tax-credit-5-revisor"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5Revisor">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Indicare se il bilancio della società viene sottoposto a revisione
                                            contabile.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.TaxCredit5Revisor" class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        Contatto e-mail del revisore legale dei conti
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="email"
                                               id="tax-credit-5-revisor-email"
                                               name="tax-credit-5-revisor-email"
                                               class="form-control"
                                               placeholder="Inserisci il contatto e-mail del revisore legale dei conti"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(revisorEmail.valid || revisorEmail.pristine),
                                                'form-success': revisorEmail.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5RevisorEmail"
                                               #revisorEmail="ngModel">
                                        <i class="icon-envelope"></i>
                                        <div [hidden]="revisorEmail.valid || revisorEmail.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.TaxCredit5Revisor" class="form-group">
                                    <label for="ateco-code" class="col-sm-3 control-label">
                                        Contatto telefonico del revisore legale dei conti
                                    </label>
                                    <div class="col-sm-9 prepend-icon m-t-10">
                                        <input type="tel"
                                               id="tax-credit-5-revisor-phone"
                                               name="tax-credit-5-revisor-phone"
                                               class="form-control"
                                               placeholder="Inserisci il contatto telefonico del revisore legale dei conti"
                                               minlength="2"
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(revisorPhone.valid || revisorPhone.pristine),
                                                'form-success': revisorPhone.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5RevisorPhone"
                                               #revisorPhone="ngModel">
                                        <i class="icon-call-in"></i>
                                        <div [hidden]="revisorPhone.valid || revisorPhone.pristine"
                                             class="form-error valid">
                                            Inserisci almeno 2 caratteri.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Esistono altri progetti di innovazione 5.0 in corso?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-projects"
                                                         name="tax-credit-5-projects"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5OtherProjects">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La vostra attività imprenditoriale genera un’elevata dose di sostanze
                                        inquinanti classificabili come rifiuti speciali pericolosi?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-waste"
                                                         name="tax-credit-5-waste"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5SpecialWaste">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        La {{ customer.CompanyName }} è proprietaria o affittuaria della struttura
                                        produttiva dove intende fare l’investimento?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-structure-owner"
                                                         name="tax-credit-5-structure-owner"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5StructureOwner">
                                            <mat-radio-button
                                                    *ngFor="let radioStructureOwnerOption of radioStructureOwnerOptions"
                                                    [value]="radioStructureOwnerOption">
                                                <span style="font-weight: 400 !important;">{{ radioStructureOwnerOption }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        Il progetto di innovazione rispetta il principio DNSH?
                                    </label>
                                    <div class="text-center m-b-10">
                                        <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(14)">
                                            <i class="fa fa-video-camera"></i>Pillola Informativa
                                        </button>
                                    </div>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-dnsh"
                                                         name="tax-credit-5-dnsh"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5DNSH">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group">
                                    <label for="tax-credit-5-start-date" class="col-sm-3 control-label">Data presunta di avvio dell'investimento</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-5-start-date"
                                               name="tax-credit-5-start-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di avvio dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5StartDate.valid || taxCredit5StartDate.pristine),
                                                'form-success': taxCredit5StartDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5StartDate"
                                               #taxCredit5StartDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="form-group">
                                    <label for="tax-credit-5-end-date" class="col-sm-3 control-label">Data presunta di conclusione dell'investimento (data stimata di consegna del bene)</label>
                                    <div class="col-sm-9 prepend-icon">
                                        <input type="date"
                                               id="tax-credit-5-end-date"
                                               name="tax-credit-5-end-date"
                                               class="form-control"
                                               placeholder="Indica la data presunta di conclusione dell'investimento"
                                               minlength="2"
                                               required
                                               autocomplete="off"
                                               [ngClass]="{
                                                'form-error': !(taxCredit5EndDate.valid || taxCredit5EndDate.pristine),
                                                'form-success': taxCredit5EndDate.valid
                                           }"
                                               [(ngModel)]="request.TaxCredit5EndDate"
                                               #taxCredit5EndDate="ngModel">
                                        <i class="icon-calendar"></i>
                                    </div>
                                </div>

                                <div *ngIf="false" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L'investimento sarà completato entro il 31/12/2025?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-year-end"
                                                         name="tax-credit-5-year-end"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5YearEnd">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType !== 5" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L’investimento programmato ha uno scopo di "ampliamento aziendale"?
                                    </label>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="business-expansion"
                                                         name="business-expansion"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.BusinessExpansion">
                                            <mat-radio-button *ngFor="let radioBasicOption of radioBasicOptions"
                                                              [value]="radioBasicOption.value">
                                                <span style="font-weight: 400 !important;">{{ radioBasicOption.label }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                        <div class="info-box">
                                            <i class="fa fa-info-circle"></i>
                                            Si ricorda che l’agevolazione non è riconosciuta in caso di
                                            sostituzione/permuta del bene oggetto di investimento.
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="request.FKIDRequestType === 5" class="form-group m-b-30">
                                    <label class="col-12 control-label">
                                        L’investimento programmato ha uno scopo di "ampliamento aziendale" o di
                                        "sostituzione"?
                                    </label>
                                    <div class="text-center m-b-10">
                                        <button class="btn btn-embossed btn-success btn-xs" (click)="openVideoModal(13)">
                                            <i class="fa fa-video-camera"></i>Pillola Informativa
                                        </button>
                                    </div>
                                    <div class="col-12 text-center">
                                        <mat-radio-group id="tax-credit-5-business-expansion"
                                                         name="tax-credit-5-business-expansion"
                                                         [color]="'primary'"
                                                         [(ngModel)]="request.TaxCredit5BusinessExpansion">
                                            <mat-radio-button
                                                    *ngFor="let radioTaxCredit5BusinessExpansion of radioTaxCredit5BusinessExpansionOptions"
                                                    [value]="radioTaxCredit5BusinessExpansion">
                                                <span style="font-weight: 400 !important;">{{ radioTaxCredit5BusinessExpansion }}</span>
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <div *ngIf="getMissingFieldsStep3().length > 0"
                                     class="alert alert-danger text-left m-t-30">
                                    <strong>Devi ancora completare i seguenti dati per proseguire:</strong>
                                    <ul style="margin-bottom: 0; padding-left: 20px;">
                                        <li *ngFor="let field of getMissingFieldsStep3()">
                                            {{ field }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-default"
                                            (click)="goStepBackward()">
                                        <i class="fa fa-arrow-left"></i>Indietro
                                    </button>
                                    <button type="submit"
                                            class="btn btn-embossed btn-primary"
                                            (click)="goStepForward(step3Form)"
                                            [disabled]="!canAdvanceFromCurrentStep(step3Form)">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Vai al passaggio successivo
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 4 && request.FKIDRequestType !== 7 && !hyperDepreciationContractStep" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                        <div *ngIf="request.FKIDRequestType !== 5" class="col-sm-8 offset-sm-2 warrant-acceptance">
                            <p>
                                Il/La sottoscritto/a Sig./Sig.ra {{ customer.Name }} {{ customer.Surname }} nato/a a
                                {{ customer.BirthPlace }} il {{ customer.BirthDate | date:'dd/MM/yyyy' }}, residente a {{ customer.City }}, in qualità di legale rappresentante della Società/Ditta Individuale {{ customer.CompanyName }} con P.IVA n. {{ customer.VATNumber }} conferisce alla società "TEVANPAL CONSULT SRL UNIPERSONALE" con sede legale in Via Nomentana 351/A Fonte Nuova (RM), con codice fiscale e partita Iva 17772961003, rappresentata dal <strong>Dott. Commercialista Pierluca Evangelista</strong> nato a Roma il 02/09/1998, l’autorizzazione all'accesso in "Piattaforma Sabatini" tramite SPID, e il seguente incarico professionale:
                            </p>
                            <ul>
                                <li>
                                    Compilazione e predisposizione della “Domanda Nuova Sabatini” per l’invio alla
                                    società di leasing indicata dal cliente;
                                </li>
                                <li>
                                    Compilazione e predisposizione della “Richiesta Erogazione” del contributo
                                    economico previsto dal Ministero delle Imprese e del Made in Italy;
                                </li>
                                <li>
                                    Conferimento "Procura Speciale" con l’incarico di sottoscrivere con firma digitale
                                    ed inviare tramite Posta Elettronica Certificata la “Domanda Nuova Sabatini”.
                                </li>
                            </ul>
                            <p>
                                Ai fini del predetto incarico, il legale rappresentante della società/titolare della
                                ditta individuale , conferisce al dott. Evangelista Pierluca nato a Roma il 02/09/1998,
                                in qualità di amministratore e legale rappresentante della società “TEVANPAL CONSULT
                                SRL UNIPERSONALE”, apposita procura con l’incarico di sottoscrivere con firma digitale ed inviare
                                tramite Posta Elettronica Certificata, alla banca prescelta, la “Domanda Nuova Sabatini”
                                per accedere ad un finanziamento ai sensi dell’art. 2 D.L. 69 del 21/06/13 convertito
                                con modificazioni nella legge 9/08/13, n. 98 e per accedere alle agevolazioni di cui
                                all’art. 6 DM 27/11/2013 (così detta Nuova Sabatini), pubblicato sulla Gazzetta
                                Ufficiale del 24/01/2014 n. 19, il D.L. n. 3 del 24/01/2015 convertito con modificazioni
                                nella legge 24/03/15, n. 33 ed il decreto interministeriale 25/01/2016, pubblicato sulla
                                Gazzetta Ufficiale del 10/03/2016 n. 58 in relazione al finanziamento/ leasing di beni
                                strumentali, delegando lo stesso alla presentazione ed al successivo espletamento di
                                ogni attività connessa a tale procedimento e attribuendogli allo scopo ogni più ampia
                                facoltà di legge, con promessa fin d’ora di rato e valido del suo operato. Il modulo per
                                la richiesta di finanziamento verrà inviato tramite indirizzo PEC / mail :
                                tevanpalconsultsrl@legalmail.it.
                            </p>
                            <p>
                                Il CLIENTE concede alla SOCIETA’ il diritto di impiegare la propria denominazione
                                ed il logo per finalità di materiale di marketing da effettuarsi mediante invio di
                                brochure a clienti acquisiti e/o da acquisire, oltre che l'inserimento del proprio
                                nominativo tra le referenze del proprio sito web, anche attraverso l’utilizzo del logo
                                del CLIENTE presente sul suo sito internet. Dal predetto impiego non dovranno
                                desumersi elementi del mandato conferito o del progetto concordato con il CLIENTE.
                            </p>
                            <p>
                                La SOCIETA’ “TEVANPAL CONSULT SRL UNIPERSONALE” non risponde né garantisce il buon esito
                                della
                                richiesta di accesso all’agevolazione “Domanda Nuova Sabatini” presentata a nome e per
                                conto del committente. La Società è esonerata da ogni responsabilità per ritardi e/o
                                imputabili al committente oltre che nei casi di forza maggiore (ritardi da parte
                                dell’Ente erogatore) ovvero mutamenti legislativi e regolamentari.
                            </p>
                            <p>
                                Il CLIENTE si impegna a collaborare per la predisposizione della “Domanda Nuova
                                Sabatini”, fornendo senza ritardi le informazioni e/o i documenti richiesti da “TEVANPAL
                                CONSULT SRL UNIPERSONALE”.
                            </p>
                            <p>
                                Il CLIENTE si impegna ad adempiere al pagamento del compenso previsto anche in caso di
                                revoca del contratto di consulenza.
                            </p>
                            <p>
                                <strong>Deposito della documentazione:</strong> La società "TEVANPAL CONSULT SRL
                                UNIPERSONALE" è
                                autorizzata a trattenere presso la sua sede la documentazione fornita dal cliente
                                necessaria all’espletamento dell’incarico e a conservarla su supporto elettronico. La
                                Società “TEVANPAL CONSULT SRL UNIPERSONALE” è inoltre autorizzata al trattamento dei
                                dati personali.
                            </p>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>

                                <button type="submit"
                                        *ngIf="request.FKIDRequestType !== 6"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                                <button type="submit"
                                        *ngIf="request.FKIDRequestType === 6"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForwardContract()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="request.FKIDRequestType === 5" class="col-sm-8 offset-sm-2 warrant-acceptance">
                            <p>
                                Con la presente scrittura privata, redatta in duplice originale e che si compone di
                                numero sei
                                pagine e numero undici articoli, valevole ad ogni effetto di legge, fra le parti
                                contraenti:
                            </p>
                            <p>
                                - <strong style="text-transform: uppercase;">{{ customer.CompanyName }}</strong>, P.IVA:
                                <strong>{{ customer.VATNumber }}</strong>, con sede legale in
                                {{ customer.Address }} {{ customer.HouseNumber }}, {{ customer.HeadOffice }}
                                ({{ customer.HeadOfficeProvince }}),
                                in persona del legale rappresentante p.t.
                                <strong>{{ customer.Name }} {{ customer.Surname }}</strong> (nato a
                                {{ customer.BirthPlace }} il {{ customer.BirthDate | date:'dd/MM/yyyy' }}), di seguito denominata
                            </p>
                            <p style="text-align: right;">
                                <strong><em>(Cliente)</em></strong>
                            </p>
                            <p>
                                - <strong>TEVANPAL CONSULT S.R.L. UNIPERSONALE</strong>, P.IVA
                                <strong>17772961003</strong>,
                                con sede legale in Via Nomentana 351/A Fonte Nuova (RM), identificata con N. REA:
                                RM-1740352,
                                in persona dell’Amministratore Unico e legale rappresentante p.t. <strong>Dott.
                                Commercialista Pierluca
                                Evangelista</strong> (nato a Roma il 02.09.1998 - C.F. VNGPLC98P02H501M), di seguito
                                denominata
                            </p>
                            <p style="text-align: right;">
                                <strong><em>(Consulente)</em></strong>
                            </p>
                            <p style="text-align: center;"><strong>Premesso che:</strong></p>
                            <ul>
                                <li>
                                    Tevanpal Consult S.r.l. unipersonale, di seguito denominata anche Consulente o
                                    Società di
                                    Consulenza, opera nel settore della consulenza fiscale supportando le imprese nello
                                    studio e nell’ottenimento delle migliori agevolazioni fiscali, per l’acquisto di
                                    nuovi beni
                                    strumentali e per progetti d’innovazione sostenibile, rientranti nel paradigma
                                    dell'Industria
                                    4.0 e 5.0.;
                                </li>
                                <li>
                                    il Cliente intende avvalersi dei benefici previsti dal "Credito d'Imposta 5.0" ai
                                    sensi dell'art.
                                    38 del Decreto-Legge 2 marzo 2024, n. 19, convertito con modificazioni, dalla legge
                                    29
                                    aprile 2024, n. 56, recante “Ulteriori disposizioni urgenti per l’attuazione del
                                    Piano nazionale
                                    di ripresa e resilienza (PNRR)” per un progetto di investimento da quest’ultimo
                                    avviato, o
                                    da avviare, e ritenuto idoneo ai requisiti previsti dalla normativa vigente che
                                    introduce un
                                    credito d’imposta per le imprese che effettuano nuovi investimenti, a decorrere dal
                                    1
                                    gennaio 2024 e fino al 31 dicembre 2025, destinati ad aziende ubicate nel territorio
                                    dello
                                    Stato italiano, nell’ambito di progetti di innovazione che comportano una riduzione
                                    dei
                                    consumi energetici della struttura produttiva non inferiore al 3% od in alternativa,
                                    una
                                    riduzione dei consumi energetici dei processi interessati dall’investimento non
                                    inferiore al
                                    5%;
                                </li>
                                <li>
                                    con il decreto interministeriale del 24 luglio 2024 sono individuate le modalità
                                    attuative
                                    della disciplina del nuovo Credito d’Imposta, con particolare riferimento all’ambito
                                    soggettivo e oggettivo, nonché alla misura del beneficio, alle disposizioni
                                    concernenti la
                                    procedura di accesso all’agevolazione, alla relativa fruizione e ai connessi oneri
                                    documentali;
                                </li>
                                <li>
                                    con il decreto direttoriale 6 agosto 2024 è stata disposta l’apertura dal giorno 7
                                    agosto
                                    2024 della Piattaforma Informatica “Transizione 5.0” accessibile dal sito del
                                    “Gestore dei
                                    Servizi Energetici” (GSE), per la presentazione delle comunicazioni preventive
                                    dirette alla
                                    prenotazione del Credito d’Imposta “Transizione 5.0” e delle comunicazioni di
                                    conferma
                                    relative all’effettuazione degli ordini accettati dal venditore con pagamento a
                                    titolo di
                                    acconto in misura almeno pari al 20% del costo di acquisizione;
                                </li>
                                <li>
                                    con il decreto direttoriale 11 settembre 2024 è stata disposta l’apertura dal giorno
                                    12
                                    settembre 2024 della Piattaforma Informatica sul sito del GSE per la presentazione
                                    delle
                                    comunicazioni di completamento dei progetti di innovazione;
                                </li>
                                <li>
                                    il 16 agosto 2024 è stata pubblicata, sul sito internet del Ministero delle Imprese
                                    e del Made
                                    in Italy, la Circolare Operativa “Transizione 5.0”, il cui scopo è fornire
                                    chiarimenti tecnici in
                                    relazione a specifici profili, utili ai fini della corretta applicazione della nuova
                                    disciplina
                                    agevolativa;
                                </li>
                                <li>
                                    TEVANPAL CONSULT SRL UNIPERSONALE per la gestione dell’intero iter agevolativo e per
                                    la
                                    raccolta documentale, utilizzerà la piattaforma, di sua proprietà, denominata
                                    “TevanManager” nella quale il Cliente caricherà tutti i documenti richiesti e
                                    fornirà i dati e
                                    le informazioni necessarie per l’accesso al beneficio “Transizione 5.0”;
                                </li>
                                <li>
                                    il Cliente si impegna, nell’ambito del progetto di investimento denominato
                                    “Transizione
                                    5.0”, a versare un acconto, non inferiore al 20%, al fornitore del bene oggetto di
                                    investimento o a stipulare apposito contratto di leasing/finanziamento bancario,
                                    entro 30
                                    giorni dalla data di ricezione della ricevuta di presentazione della “comunicazione
                                    ex
                                    ante”;
                                </li>
                                <li>
                                    il Cliente autorizza il Consulente a registrare la sua impresa, presso il portale
                                    “Area Clienti
                                    GSE” e ad associare la sua utenza a quella del rappresentante legale della Tevanpal
                                    Consult Srl Unipersonale, per attivare la funzionalità “Transizione 5.0”. In
                                    alternativa,
                                    qualora il Cliente risulti già registrato all’”Area Clienti GSE”, ai fini
                                    dell’associazione verrà
                                    richiesto al Cliente apposito “Codice Pin” rilasciato dal GSE all’atto di
                                    registrazione;
                                </li>
                                <li>
                                    il Cliente si impegna ad inviare tutta la documentazione richiesta, aggiornata alla
                                    data di
                                    invio; il cliente in persona del legale rappresentante p.t. si impegna a firmare
                                    digitalmente
                                    (in formato P7M) la documentazione generata dal portale del GSE e inviata tramite
                                    email
                                    dalla Società di Consulenza;
                                </li>
                                <li>
                                    il servizio prestato rientra nell’ambito dei rapporti di consulenza e dunque nella
                                    più ampia
                                    categoria della prestazione d’opera intellettuale e come tale, regolato dagli artt.
                                    2230 e ss.
                                    c.c., ed in quanto compatibili con le norme richiamate e con la natura del rapporto
                                    dalle
                                    disposizioni di cui al Titolo Terzo, Libro Quinto del Codice Civile. L’obbligazione
                                    assunta
                                    dalla Società di Consulenza è un’obbligazione di mezzi che comporta un’assunzione di
                                    responsabilità nei limiti del corretto svolgimento delle attività determinate dal
                                    presente
                                    contratto, nel rispetto dei criteri di diligenza qualificata ex art. 1176 c.c..
                                </li>
                            </ul>
                            <p style="text-align: center;"><strong>Tutto ciò premesso</strong></p>
                            <p><strong>Art. 1 - Premessa</strong></p>
                            <p>La premessa costituisce parte integrante e sostanziale del presente contratto.</p>
                            <p><strong>Art. 2 - Oggetto della Consulenza e modalità di svolgimento
                                dell’incarico</strong></p>
                            <p>
                                Tevanpal Consult Srl Unipersonale si impegna a fornire al Cliente un servizio di
                                consulenza
                                professionale finalizzato all'accesso al "Credito d'Imposta 5.0", attraverso le seguenti
                                attività:
                            </p>
                            <ol type="A">
                                <li>
                                    <strong>Raccolta documentale e analisi di prefattibilità:</strong>
                                    <ul>
                                        <li>
                                            Verifica dell'ammissibilità del progetto di investimento al "Credito
                                            d'Imposta 5.0", ai sensi
                                            dell'art. 38 del Decreto-Legge 2 marzo 2024, n. 19;
                                        </li>
                                        <li>
                                            Analisi preliminare della documentazione fornita dal Cliente per valutare la
                                            congruità e la
                                            completezza delle informazioni necessarie.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Accesso e gestione del Portale GSE:</strong>
                                    <ul>
                                        <li>
                                            Iscrizione e accesso al Portale del GSE per la registrazione e
                                            l'associazione tra l'utenza del
                                            Cliente e quella del Consulente, rappresentato dal Dott. Commercialista
                                            Pierluca
                                            Evangelista;
                                        </li>
                                        <li>
                                            Creazione di un "Nuovo Progetto" sul Portale, comprensivo dell'inserimento e
                                            gestione di
                                            tutti i dati necessari;
                                        </li>
                                        <li>
                                            Gestione dell’intero iter burocratico, comprensivo di:
                                            <ul>
                                                <li>
                                                    Invio della documentazione prevista, inclusa la <strong>Dichiarazione
                                                    Sostitutiva di Atto Notorio (DSAN)</strong> firmata dal legale
                                                    rappresentante del Cliente;
                                                </li>
                                                <li>
                                                    Caricamento di tutti i documenti necessari per l’invio delle
                                                    comunicazioni ex ante,
                                                    intermedie ed ex post.
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Coordinamento con i professionisti incaricati dal Cliente:</strong><br/>
                                    L’espletamento della prestazione oggetto del presente contratto richiede la
                                    necessaria
                                    collaborazione di tutte o alcune delle figure professionali sotto elencate e
                                    descritte. La Società
                                    di Consulenza, ove il Cliente non avesse ad indicare figure professionali di
                                    fiducia, proporrà a
                                    quest’ultimo le professionalità necessarie per l’espletamento delle attività in
                                    oggetto. Il Cliente
                                    avrà comunque la possibilità di incaricare propri professionisti di fiducia
                                    rientrati nella
                                    categoria professionale indicata dalla Società di Consulenza purché dotati delle
                                    qualifiche
                                    necessarie oppure di avvalersi di quelli indicati dalla stessa società, in ogni caso
                                    il cliente
                                    conferirà incarico specifico a detti professionisti, i quali dunque, opereranno
                                    assumendo
                                    impegni diretti con il Cliente, coordinati dalla Società di Consulenza ai fini della
                                    valutazione e
                                    realizzazione del progetto di investimento. Le figure professionali necessarie sono
                                    indicate in
                                    quelle seguenti:
                                    <ul>
                                        <li>Ingegnere energetico/ESCO;</li>
                                        <li>Ingegnere 4.0;</li>
                                        <li>
                                            Revisore legale dei conti esterno o Revisore legale dei conti/sindaco
                                            unico/collegio
                                            sindacale interno;
                                        </li>
                                        <li>Fornitore/Agente di commercio/Rappresentante del bene oggetto di
                                            investimento;
                                        </li>
                                        <li>Consulente fiscale o Commercialista del Cliente;</li>
                                        <li>
                                            Mediatore di leasing/Consulente finanziario o funzionario Banca/Società di
                                            leasing del
                                            Cliente
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Redazione e gestione del Dossier:</strong>
                                    <ul>
                                        <li>
                                            Redazione di un Dossier completo contenente tutta la documentazione relativa
                                            alla
                                            fruizione del "Credito d'Imposta 5.0", conforme alle disposizioni normative
                                            e da esibire in
                                            caso di controlli da parte di Agenzia delle Entrate, Guardia di Finanza e
                                            GSE.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Coordinamento con il consulente fiscale del Cliente:</strong>
                                    <ul>
                                        <li>
                                            La Società di Consulenza affiancherà il fiscalista del Cliente per la
                                            gestione della
                                            compensazione in F24 del "Credito d'Imposta 5.0", assicurando che tutte le
                                            operazioni
                                            siano conformi alla normativa fiscale vigente.
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                            <p><strong>Art. 3 - Impegni ed obblighi del Cliente</strong></p>
                            <p>
                                Il Cliente si impegna espressamente a collaborare con la Società di Consulenza in modo
                                da
                                rendere possibile lo svolgimento della prestazione. In particolare, entro e non oltre i
                                termini
                                indicati dal Consulente, il Cliente si impegna a fornire al medesimo tutte le
                                informazioni, i dati,
                                i documenti, le dichiarazioni e le certificazioni necessarie e utili al corretto
                                svolgimento della
                                prestazione, aggiornate e prive di errori o incompletezze. Il Cliente si impegna ad
                                adempiere
                                al pagamento del compenso previsto ed al rimborso delle spese vive documentate,
                                sostenute dalla Società di Consulenza.
                            </p>
                            <p><strong>Art. 4 - Impegni, obblighi e responsabilità della Società di Consulenza</strong>
                            </p>
                            <p>
                                Il Consulente si impegna a svolgere le proprie attività con la diligenza qualificata
                                prevista
                                dall’art. 1176 c.c. e a tenere il Cliente informato sull'andamento della pratica tramite
                                periodica
                                rendicontazione dell’attività svolta. L’esito della richiesta di accesso
                                all’agevolazione “Credito
                                d’imposta 5.0”, presentata a nome e per conto del Cliente, dipendendo dall’Ente gestore
                                dell’agevolazione fiscale, non può far carico al Consulente, il quale resta responsabile
                                del
                                corretto adempimento delle obbligazioni contratte con il presente incarico. La Società
                                di
                                Consulenza è esonerata da ogni responsabilità per ritardi od errori imputabili al
                                committente,
                                oltre che nei casi di forza maggiore, tra i quali sono da comprendersi a mero titolo
                                esemplificativo e non esaustivo anche ritardi, errori od inadempimenti da parte
                                dell’Ente
                                gestore della misura agevolativa, ovvero mutamenti legislativi e/o regolamentari
                                attinenti le
                                agevolazioni fiscali in oggetto. La Società di Consulenza è altresì esonerata da ogni
                                responsabilità in caso di inadempimento causato da ritardi o inadempienze degli altri
                                professionisti incaricati, i quali sono personalmente ed esclusivamente responsabili del
                                loro
                                operato, ancorché soggetti alla coordinazione del Consulente ma senza vincolo di
                                subordinazione a quest’ultimo. <strong>Si conviene che le prestazioni oggetto del
                                presente contratto
                                rientrano fra quelle di speciale difficoltà di cui all’art. 2236 c.c..</strong>
                            </p>
                            <p><strong>Art. 5 - Durata del Contratto</strong></p>
                            <p>
                                Il presente contratto decorrerà dalla data di sottoscrizione fino al completamento delle
                                attività oggetto della consulenza, come sopra descritte. Salvo i casi di risoluzione o
                                recesso per come disciplinati dal presente contratto.
                            </p>
                            <p><strong>Art. 6 - Compenso e Modalità di Pagamento</strong></p>
                            <p>
                                Il Cliente si impegna a corrispondere alla Società di Consulenza un compenso per i
                                servizi
                                prestati, come segue:
                            </p>
                            <ul>
                                <li>Compenso totale per le attività di consulenza: {{ request.PaymentDetails }} + IVA
                                </li>
                                <li>
                                    Modalità di pagamento: l’importo di cui sopra sarà pagato in tre rate così
                                    suddivise:
                                    <ul>
                                        <li>
                                            <strong>prima rata:</strong> pari al 20% del compenso totale all’atto di
                                            sottoscrizione del presente
                                            contratto di consulenza;
                                        </li>
                                        <li>
                                            <strong>seconda rata:</strong> pari al 40% del compenso totale all’atto di
                                            presentazione della
                                            comunicazione intermedia e alla ricezione della relativa ricevuta;
                                        </li>
                                        <li>
                                            <strong>terza rata:</strong> pari al 40% del compenso totale all’atto di
                                            presentazione della comunicazione
                                            di completamento e alla ricezione della relativa ricevuta.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <p>
                                In caso di mancato pagamento entro i termini stabiliti, la Società di Consulenza si
                                riserva la
                                facoltà di risolvere il contratto in essere imputando gli acconti corrisposti
                                all’attività espletata
                                e salvo il maggior danno.
                            </p>
                            <p><strong>Art. 7 - Diritto di recesso</strong></p>
                            <p>
                                Ciascuna delle parti avrà facoltà di recedere dal rapporto in qualsiasi momento, dandone
                                comunicazione all'altra mediante posta elettronica certificata e/o lettera raccomandata
                                A.R.,
                                con un preavviso di almeno giorni 30 rispetto alla data in cui intende far valere il
                                recesso. In
                                caso di recesso del Cliente, questo dovrà rimborsare alla Società di consulenza tutte le
                                spese
                                vive sostenute e corrispondere il compenso per l'attività svolta, nel caso il recesso
                                avvenga
                                successivamente all’avvenuta “comunicazione intermedia” il Cliente sarà comunque tenuto
                                al pagamento del totale del compenso pattuito. La Società di Consulenza potrà recedere
                                dal
                                contratto solo per giusta causa, determinata dai reiterati inadempimenti del cliente,
                                salvo
                                diritto al rimborso delle spese vive sostenute ed al compenso per l'attività svolta.
                            </p>
                            <p><strong>Art. 8 - Risoluzione del contratto</strong></p>
                            <p>
                                In caso di grave inadempimento di una delle Parti, il contraente adempiente ha diritto a
                                risolvere il contratto con effetto immediato, a mezzo di motivata comunicazione
                                inoltrata
                                all’altra parte con posta elettronica certificata e/o lettera raccomandata A.R., fatto
                                salvo il
                                risarcimento del danno. Il mancato pagamento delle somme, alle scadenze pattuite, è da
                                considerarsi per gli effetti del presente articolo un grave inadempimento. In ogni caso
                                il
                                risarcimento del danno non potrà mai esigersi in misura superiore al doppio del valore
                                del
                                compenso stabilito con il presente contratto. La risoluzione in ogni caso non
                                pregiudicherà i
                                diritti spettanti a ciascuna delle parti e già maturati alla data della risoluzione.
                            </p>
                            <p><strong>Art. 9 - Riservatezza e Privacy</strong></p>
                            <p>
                                Il Consulente si impegna a mantenere riservate tutte le informazioni ed i dati sensibili
                                acquisiti nel corso dell'esecuzione del presente contratto, anche successivamente alla
                                sua
                                conclusione, a non utilizzarli per finalità diverse da quelle oggetto del presente
                                contratto,
                                senza apposito consenso per iscritto del Cliente, fatte salve le informazioni di
                                pubblico
                                dominio.
                                La Società di Consulenza è autorizzata altresì a trattenere, presso la sua sede ed in
                                formato
                                digitale tramite il suo portale “TevanManager”, tutta la documentazione fornita dal
                                Cliente
                                necessaria all’espletamento dell’incarico e a conservarla a sua spesa e cura su adeguato
                                supporto elettronico. La Società di Consulenza è infine espressamente autorizzata al
                                trattamento dei dati personali in conformità all’art. 28 del Regolamento UE 679/2016
                                (GDPR)
                                nonché al D.lgs. 196/2003 e successive modifiche, per le finalità connesse
                                all’esecuzione del
                                presente contratto.
                            </p>
                            <p><strong>Art. 10 - Clausole Finali</strong></p>
                            <ul>
                                <li>
                                    <strong>Foro competente:</strong> Ogni controversia derivante dall'interpretazione,
                                    esecuzione ovvero
                                    risoluzione del presente contratto sarà devoluta alla competenza esclusiva del Foro
                                    di
                                    Roma.
                                </li>
                                <li>
                                    <strong>Modifiche e/o integrazioni al contratto:</strong> Eventuali modifiche o
                                    addenda al presente
                                    contratto dovranno essere effettuate per iscritto e sottoscritte da entrambe le
                                    Parti.
                                </li>
                                <li>
                                    <strong>Legge applicabile:</strong> Il presente contratto è regolato dalla legge
                                    italiana.
                                </li>
                            </ul>
                            <p><strong>Art. 11 - Allegati</strong></p>
                            <p>
                                Costituiscono parte integrante del presente contratto i seguenti allegati:
                            </p>
                            <ol type="A">
                                <li>File EXPORT.txt relativo alla compilazione dei dati sulla Piattaforma online
                                    "Tevanpal"
                                </li>
                            </ol>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 4 && (request.FKIDRequestType === 7 || (request.FKIDRequestType === 6 && hyperDepreciationContractStep))" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 warrant-acceptance">
                            <p style="text-align: center;"><strong>CONTRATTO DI CONSULENZA FISCALE - IPERAMMORTAMENTO 4.0 -</strong></p>
                            <p style="text-align: center;"><strong><u>TRA</u></strong></p>
                            <p>
                                <strong>TEVANPAL CONSULT S.R.L. UNIPERSONALE</strong>, P.IVA: <strong>17772961003</strong>, con sede legale in Via Nomentana 351/A, Fonte Nuova (RM), identificata con N. REA: RM-1740352, in persona dell’Amministratore Unico e legale rappresentante p.t., <strong>Dott. Commercialista Pierluca Evangelista</strong> (C.F. VNGPLC98P02H501M), di seguito denominata <strong>Consulente</strong> o <strong>Società di Consulenza</strong>;</p>
                            <p style="text-align: center;"><strong><u>E</u></strong></p>
                            <p>
                                <strong>{{ customer.CompanyName }}</strong>, P.IVA: <strong>{{ customer.VATNumber }}</strong>, con sede legale in {{ customer.Address }} {{ customer.HouseNumber }}, {{ customer.HeadOffice }} ({{ customer.HeadOfficeProvince}}), in persona del legale rappresentante p.t. <strong>{{ customer.Name }} {{ customer.Surname }}</strong> di seguito denominata <strong>Cliente</strong>;</p>
                            <p style="text-align: center;"><strong><u>premesso che:</u></strong></p>
                            <ul>
                                <li>
                                    Tevanpal Consult S.r.l. unipersonale, opera nel settore della consulenza fiscale, assistendo piccole e medie imprese nello studio e nel conseguimento delle migliori agevolazioni fiscali, nelle forme del credito d’imposta e delle deduzioni, come previste dalla “Nuova Sabatini”, dal “Credito d’Imposta ZES e ZLS”, dall’“Iperammortamento 4.0” e similari;
                                </li>
                                <li>
                                    il Cliente intende avvalersi dei benefici previsti dall’<strong>Iperammortamento 4.0</strong>, come introdotto dall’art. 1 comma 427, Legge n. 199/2025, il quale prevede deduzioni maggiorate delle quote di ammortamento per gli investimenti in beni strumentali realizzati dal 1° gennaio 2026 al 30 settembre 2028 ed orientati alla digitalizzazione e all’efficientamento energetico dell’impresa;
                                </li>
                                <li>
                                    <u>il Cliente dichiara e garantisce di essere a conoscenza:</u>
                                    <ul>
                                        <li>
                                            delle previsioni normative inerenti all’Iperammortamento 4.0 e di soddisfare tutti i requisiti previsti per l’accesso a tale beneficio, tra cui il rispetto delle norme in materia di sicurezza sul lavoro e di regolarità contributiva, attestate dal possesso di valido DURC, e che l’eventuale violazione dei requisiti richiesti comporterà la decadenza del beneficio fiscale, oltre ad ulteriori conseguenze sanzionatorie;
                                        </li>
                                        <li>
                                            che, per i beni con costo unitario superiore a 300.000,00 Euro è obbligatoria la produzione di perizia tecnica asseverata ovvero l’attestato di conformità di ente accreditato, mentre per i beni di importo inferiore, è ammessa la dichiarazione sostitutiva del legale rappresentante. È sempre necessaria la certificazione contabile delle spese, che può essere rilasciata da un revisore legale dei conti o da una società di revisione;
                                        </li>
                                        <li>
                                            della presenza di un meccanismo di recapture, il quale prevede la revoca dell’Iperammortamento residuo, nel caso in cui il bene agevolato venga ceduto o destinato all’estero prima del termine dell’ammortamento (la revoca non opera se, nello stesso periodo d’imposta, il bene è sostituito con un altro bene nuovo 4.0);
                                        </li>
                                        <li>
                                            di tutte le ulteriori norme previste dai commi 427 ss. dell’art. 1 L. 199/2025, in tema di individuazione dei beni agevolabili, quote di maggiorazione, modalità di richiesta e gestione della domanda, oneri e responsabilità del richiedente ed ogni altra previsione ivi prevista, come sinteticamente riportato dal documento “Guida all’Iperammortamento 4.0” allegato.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    il Consulente, per la gestione dell’intero iter agevolativo e per la raccolta documentale, utilizzerà la piattaforma, di sua proprietà, denominata “<strong>Tevanpal</strong>” nella quale il Cliente caricherà tutti i documenti richiesti e fornirà i dati e le informazioni necessarie per l’accesso al beneficio fiscale oggetto del presente contratto;
                                </li>
                                <li>
                                    il Cliente si impegna, nell’ambito del progetto di investimento per il quale si richiede l’incentivo fiscale, a versare un acconto, non inferiore al 20% del prezzo pattuito, al fornitore del bene oggetto di investimento, entro il termine indicato dal Consulente, necessario per la produzione e l’invio della “comunicazione intermedia” al GSE;
                                </li>
                                <li>
                                    il Cliente autorizza il Consulente a registrare la sua impresa, presso il portale “Area Clienti GSE” e ad associare la sua utenza a quella del rappresentante legale della Tevanpal Consult S.r.l. Unipersonale. In alternativa, qualora il Cliente risulti già registrato in “Area Clienti GSE”, ai fini dell’associazione, lo stesso si impegna a fornire al Consulente le credenziali necessarie all’accesso, attivandosi, ove necessario, per tutte le verificazioni richieste;
                                </li>
                                <li>
                                    il servizio prestato da Tevanpal Consult S.r.l. rientra nell’ambito dei rapporti di consulenza e dunque nella più ampia categoria della prestazione d’opera intellettuale e come tale, regolato dagli artt. 2230 e ss. c.c., ed in quanto compatibili con le norme richiamate e con la natura del rapporto dalle disposizioni di cui al Capo Primo, Titolo Terzo, Libro Quinto del Codice Civile. L’obbligazione assunta dalla Società di Consulenza è un’obbligazione di mezzi che comporta un’assunzione di responsabilità nei limiti del corretto svolgimento delle attività determinate dal presente contratto, nel rispetto dei criteri di diligenza qualificata ex art. 1176 c.c.
                                </li>
                            </ul>
                            <p style="text-align: center;"><strong><u>Tutto ciò premesso</u></strong></p>
                            <p>Le Parti convengono e stipulano quanto segue:</p>
                            <p><strong>Art. 1 - Premessa</strong></p>
                            <p>
                                La premessa e gli allegati costituiscono parte integrante e sostanziale del presente contratto.
                            </p>
                            <p><strong>Art. 2 - Oggetto della Consulenza e modalità di svolgimento dell’incarico</strong></p>
                            <p>
                                Tevanpal Consult S.r.l. Unipersonale si impegna a fornire al Cliente un servizio di consulenza fiscale finalizzato all’accesso dell’agevolazione denominata <strong>“Iperammortamento 4.0”</strong>, attraverso le seguenti attività:
                            </p>
                            <ol class="hyper-depreciation-list">
                                <li>
                                    <strong>Raccolta documentale e analisi di prefattibilità:</strong><br />
                                    verifica dell'ammissibilità del progetto di investimento all’agevolazione fiscale denominata “Iperammortamento 4.0” ex artt. 1 comma 427 ss., Legge n. 199/2025, con contestuale analisi preliminare della documentazione fornita dal Cliente per valutare la congruità e la completezza delle informazioni necessarie all’avvio della procedura.
                                </li>
                                <li>
                                    <strong>Accesso, gestione ed invio delle comunicazioni sul Portale GSE:</strong><br />
                                    Iscrizione e accesso al Portale del GSE per la registrazione e l'associazione tra l'utenza del Cliente e quella del Consulente; censimento ed apertura del progetto d’investimento sul Portale; gestione di tutte le fasi procedimentali previste dall’invio della comunicazione preventiva alla comunicazione di completamento.
                                </li>
                                <li>
                                    <strong>Coordinamento con i professionisti incaricati dal Cliente:</strong><br />
                                    L’espletamento della prestazione oggetto del presente contratto richiede la necessaria collaborazione di tutte o alcune delle figure professionali sotto elencate e descritte. La Società di Consulenza, ove il Cliente non avesse ad indicare figure professionali di fiducia, proporrà a quest’ultimo le professionalità necessarie per l’espletamento delle attività in oggetto. Il Cliente avrà comunque la possibilità di incaricare propri professionisti di fiducia rientranti nella categoria professionale indicata dalla Società di Consulenza purché dotati delle qualifiche necessarie. In ogni caso il Cliente conferirà incarico specifico a detti professionisti, i quali dunque, opereranno assumendo impegni diretti con il Cliente, soggetti alla mera
                                    coordinazione del Consulente ai fini della valutazione e realizzazione del progetto di investimento. Le figure professionali necessarie sono le seguenti:
                                    <ul>
                                        <li>Ingegnere o Perito industriale (obbligatorio per investimenti > 300.000,00 Euro);</li>
                                        <li>Revisore legale dei conti;</li>
                                        <li>Commercialista.</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Coordinamento con il consulente fiscale del Cliente:</strong><br />
                                    La Società di Consulenza affiancherà, ove necessario, il commercialista del Cliente per la gestione fiscale della maxi-deduzione prevista dall’Iperammortamento 4.0, assicurando che tutte le operazioni siano conformi alla normativa vigente in materia;
                                </li>
                            </ol>
                            <p>
                                Restano espressamente escluse, salvo diverso accordo scritto, le attività non indicate nel presente contratto come: consulenze ed adempimenti tributari diversi da quelli strettamente richiesti per il conseguimento dell’Iperammortamento 4.0; tenuta contabile; certificazioni tecniche e/o contabili; attività di revisione; attività presso terzi non strettamente necessarie.
                            </p>
                            <p><strong>Art. 3 - Impegni ed obblighi del Cliente</strong></p>
                            <p>
                                Il Cliente si impegna espressamente a collaborare con la Società di Consulenza in modo da rendere possibile lo svolgimento della prestazione. In particolare, entro e non oltre i termini indicati dal Consulente, il Cliente si impegna a fornire al medesimo tutte le informazioni, i dati, i documenti, le dichiarazioni e le certificazioni necessarie ed utili al corretto svolgimento della prestazione, aggiornate e prive di errori o incompletezze, nonché, ove richiesto, a firmare digitalmente la documentazione fornita dal Consulente. Il Cliente si impegna altresì ad adempiere al pagamento del compenso previsto, oltre che al rimborso delle spese vive documentate, sostenute dalla Società di Consulenza.
                            </p>
                            <p>
                                Il Cliente si impegna a manlevare e tenere indenne la Società di Consulenza da qualsiasi pretesa, contestazione, richiesta, sanzione e azione, connessa o conseguente all’esecuzione delle attività di cui al presente contratto, avanzata da terzi e derivante, direttamente o indirettamente, da inadempimenti, anche lievi, del Cliente o di soggetti da esso incaricati, ovvero da qualunque altra causa non imputabile al Consulente.
                            </p>
                            <p><strong>Art. 4 - Impegni, obblighi e responsabilità della Società di Consulenza</strong></p>
                            <p>
                                Il Consulente si impegna a svolgere le proprie attività con la diligenza qualificata prevista dall’art. 1176 c.c. e a tenere il Cliente informato sull'andamento della pratica tramite periodica rendicontazione dell’attività svolta. L’esito della richiesta di accesso all’agevolazione “Iperammortamento 4.0”, presentata a nome e per conto del Cliente, dipende dall’Ente gestore dell’agevolazione fiscale e non può far carico al Consulente, il quale resta responsabile unicamente del corretto adempimento delle obbligazioni contratte con il presente incarico, come descritte in premessa e nel precedente art. 2.
                            </p>
                            <p>
                                La Società di Consulenza è esonerata da ogni responsabilità per ritardi, omissioni od errori imputabili al Cliente, oltre che in presenza di caso fortuito e/o di forza maggiore, tra i quali sono da comprendersi, a mero titolo esemplificativo, anche ritardi, errori, omissioni od inadempimenti dell’Ente gestore della misura agevolativa, malfunzionamenti o interruzioni dei servizi nelle piattaforme digitali, mutamenti legislativi e/o regolamentari attinenti le agevolazioni fiscali in oggetto. La Società di Consulenza è altresì esonerata da ogni responsabilità in caso di inadempimento causato da ritardi o inadempienze degli altri professionisti incaricati, i quali sono personalmente ed esclusivamente responsabili del loro operato, in quanto soggetti alla sola mera coordinazione del Consulente e senza vincolo di subordinazione alcuno.
                            </p>
                            <p>
                                La responsabilità civile della Società di Consulenza verso il Cliente, a qualunque titolo originatasi, salvo dolo o colpa grave, è in ogni caso limitata all’importo complessivamente corrisposto dal Cliente a titolo di compenso, al netto di IVA e rimborso spese. A pena di decadenza, eventuali contestazioni nei confronti del Consulente dovranno essere mosse per iscritto dal Cliente entro 90 (novanta) giorni dal completamento delle attività ovvero dall’evento contestato.
                            </p>
                            <p><strong>Art. 5 - Durata del Contratto</strong></p>
                            <p>
                                Il presente contratto avrà decorrenza dalla data di sottoscrizione fino al completamento delle attività oggetto della consulenza, come sopra descritte. Salvi i casi di risoluzione o recesso, per come disciplinati dal presente contratto.
                            </p>
                            <p><strong>Art. 6 - Compenso e Modalità di Pagamento</strong></p>
                            <p>
                                Il Cliente si impegna a corrispondere alla Società di Consulenza il compenso per i servizi prestati nella misura e nelle seguenti modalità:
                            </p>
                            <p>
                                <strong><u>Compenso</u></strong> totale per le attività di consulenza: {{ request.PaymentCost2 }},00 + IVA
                            </p>
                            <p>
                                <strong><u>Modalità di pagamento:</u></strong> l’importo di cui sopra sarà pagato in due rate, così suddivise: <strong>prima rata</strong>, pari al <strong>50%</strong> del compenso totale, sarà corrisposta all’atto di sottoscrizione del presente contratto di consulenza; <strong>seconda rata</strong>, pari al restante <strong>50%</strong> del compenso, sarà corrisposta a seguito dell’avvenuta trasmissione al Cliente, da parte del Consulente, della comunicazione attestante l’avvenuta presentazione della “Comunicazione di completamento”, corredata della relativa ricevuta prodotta dal Portale del GSE.
                            </p>
                            <p>
                                In caso di mancato pagamento entro i termini stabiliti, la Società di Consulenza, previa formale comunicazione, potrà sospendere le attività sino al pagamento di quanto dovuto, riservandosi altresì la facoltà di risolvere il contratto in essere, imputando i versamenti ricevuti a titolo di acconto sul maggiore avere e salvo il maggior danno.
                            </p>
                            <p><strong>Art. 7 - Diritto di recesso</strong></p>
                            <p>
                                Ciascuna delle parti avrà facoltà di recedere dal rapporto in qualsiasi momento, dandone comunicazione all'altra mediante posta elettronica certificata e/o lettera raccomandata A.R., con un preavviso di almeno giorni 30 (trenta) rispetto alla data in cui intende far valere il recesso. In caso di recesso del Cliente, questi dovrà rimborsare alla Società di Consulenza tutte le spese vive sostenute e corrispondere il compenso per l'attività sino a quel momento svolta, salvo che il recesso avvenga successivamente all’avvenuta “comunicazione intermedia” posto che, in tal caso, il Cliente sarà comunque tenuto al pagamento del totale del compenso pattuito. La Società di Consulenza potrà recedere dal contratto solo per giusta causa, come a titolo esemplificativo: gravi ritardi nell’invio della documentazione, invio di documentazione errata od incompleta, false dichiarazioni etc., fatto salvo il diritto al rimborso delle spese vive sostenute ed al compenso per l'attività svolta.
                            </p>
                            <p><strong>Art. 8 - Risoluzione del contratto</strong></p>
                            <p>
                                In caso di grave inadempimento di una delle Parti, la parte adempiente ha diritto a risolvere il contratto con effetto immediato, a mezzo di motivata comunicazione inoltrata all’inadempiente con posta elettronica certificata e/o lettera raccomandata A.R., fatto salvo il risarcimento del danno. Il mancato pagamento da parte del Cliente delle somme a titolo di compenso, alle scadenze pattuite, così come indicato all’art. 6 è da considerarsi per gli effetti del presente articolo un grave inadempimento. La risoluzione in ogni caso non pregiudicherà i diritti spettanti a ciascuna delle parti e già maturati alla data della risoluzione.
                            </p>
                            <p><strong>Art. 9 - Riservatezza e Privacy</strong></p>
                            <p>
                                Il Consulente si impegna a mantenere riservate tutte le informazioni ed i dati aziendali acquisiti nel corso dell'esecuzione del presente contratto, anche successivamente alla sua conclusione, a non utilizzarli per finalità diverse da quelle oggetto del presente contratto senza apposito consenso per iscritto del Cliente, fatte salve le informazioni di pubblico dominio.
                            </p>
                            <p>
                                Le Parti dichiarano di operare nel rispetto del Regolamento (UE) 2016/679 (GDPR) e della normativa nazionale applicabile. Ciascuna Parte agisce quale titolare autonomo per i trattamenti connessi alla gestione del rapporto contrattuale di propria competenza. Nell’ipotesi in cui, ai fini dell’esecuzione dell’incarico, il Cliente comunichi al Consulente dati personali relativi a soggetti diversi dal legale rappresentante come dipendenti e/o collaboratori, ovvero nel caso in cui gli stessi siano a qualsiasi titolo contenuti nella documentazione inviata al Consulente, lo stesso sarà da considerarsi nominato quale responsabile del trattamento ai sensi dell’art. 28 GDPR. Il Consulente si impegna a trattare i dati personali per le finalità e con le modalità indicate nell’informativa allegata (documento lett. B), come sottoposta e visionata dal Cliente.
                            </p>
                            <p>
                                Il Cliente concede al Consulente il diritto di impiegare la propria denominazione ed il proprio logo, ai fini dell’eventuale predisposizione di materiale marketing o promozionale, oltre che all’inserimento degli stessi tra le referenze del proprio sito web “www.tevanpal.com”. Il predetto utilizzo deve avvenire senza che da esso si possa ingenerare confusione o far desumere differenti rapporti commerciali tra le Parti.
                            </p>
                            <p><strong>Art. 10 - Foro competente e clausole finali</strong></p>
                            <p>
                                Ogni controversia derivante dall'interpretazione, esecuzione ovvero risoluzione del presente contratto sarà devoluta alla competenza esclusiva del Foro di Roma. Eventuali modifiche o integrazioni al presente contratto dovranno essere effettuate per iscritto e sottoscritte da entrambe le Parti.
                            </p>
                            <p><strong>Documenti allegati:</strong></p>
                            <ol type="A">
                                <li>Informativa Trattamento Dati Personali.</li>
                            </ol>
    
                            <div class="col-sm-8 offset-sm-2 warrant-acceptance">
                                <div class="text-center m-t-40">
                                    <button type="button"
                                            *ngIf="!hyperDepreciationContractStep"
                                            class="btn btn-embossed btn-default"
                                            (click)="goStepBackward()">
                                        <i class="fa fa-arrow-left"></i>Indietro
                                    </button>
                                    <button type="button"
                                            *ngIf="hyperDepreciationContractStep"
                                            class="btn btn-embossed btn-default"
                                            (click)="goStepBackwardContract()">
                                        <i class="fa fa-arrow-left"></i>Indietro
                                    </button>
                                    <button type="submit"
                                            class="btn btn-embossed btn-primary"
                                            (click)="goStepForward()">
                                        <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 5 && request.FKIDRequestType !== 6 && request.FKIDRequestType !== 7" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 release-acceptance">
                            <p>
                                La società {{ customer.CompanyName }} con sede in {{ customer.HeadOffice }} in persona del
                                legale rappresentante pro tempore signor {{ customer.Name }} {{ customer.Surname }}
                            </p>
                            <ul class="list-requests">
                                <li>
                                    messo a conoscenza della normativa relativa alla Domanda Nuova Sabatini che comprende : decreto ministeriale 18 giugno 2025 - Adeguamento della disciplina degli incentivi di competenza della DGIAI all’obbligo di stipula di contratti assicurativi a copertura dei danni cagionati da calamità naturali ed eventi catastrofali; circolare direttoriale 22 luglio 2024, n. 1115 che integra e modifica la circolare n. 410823, del 6 dicembre 2022 e ss.mm.ii. ; circolare direttoriale 11 dicembre 2023, n. 50031 ; Circolare direttoriale 6 dicembre 2022, n. 410823 ; Decreto interministeriale 22 aprile 2022 , ed ogni ulteriore normativa che disciplina l'agevolazione in oggetto;
                                </li>
                                <li>
                                    messo a conoscenza della Circolare 15 febbraio 2017 n.14036. “ 7.6 , Con riferimento
                                    alla stessa domanda, gli investimenti dichiarati dalla PMI come investimenti in
                                    tecnologie digitali e investimenti in sistemi di tracciamento e pesatura dei
                                    rifiuti, se non rientranti negli elenchi di cui agli allegati 6/A e 6/B, non sono
                                    ammessi alle agevolazioni e non possono, in tale caso, essere ammessi come
                                    investimenti ordinari”;
                                </li>
                                <li>
                                    messo a conoscenza delle condizioni da rispettare per l’accesso all’agevolazione
                                    “Domanda Nuova Sabatini” tramite email inviata alla casella di posta elettronica;
                                </li>
                                <li>
                                    messo a conoscenza che il servizio prestato rientra nell’ambito dei rapporti di
                                    consulenza, l’oggetto dell’obbligazione di mezzi è una prestazione conforme al
                                    criterio della diligenza sancito dall’art. 1176 cod. civ. , a prescindere dal
                                    raggiungimento dell’obiettivo. Non si rientra per tale motivo nella fattispecie di
                                    obbligazioni di risultato disciplinate dall’art. 1218 cod. civ.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[0]">
                                    Acconsento
                                </mat-checkbox>
                            </div>

                            <p class="text-center"><strong>dichiara:</strong></p>
                            <ul class="list-requests">
                                <li *ngIf="request.FKIDRequestType !== 2">
                                    di sollevare ed esonerare nel modo più ampio, da ogni responsabilità connessa a
                                    quanto riportato sopra, il Dott. Evangelista Pierluca, in qualità di legale
                                    rappresentante della Società “TEVANPAL CONSULT SRL UNIPERSONALE” incaricata alla
                                    predisposizione della “Domanda Nuova Sabatini” e alla gestione della
                                    rendicontazione, da qualsivoglia e da tutte le responsabilità per un’eventuale
                                    perdita del contributo;
                                </li>
                                <li *ngIf="request.FKIDRequestType === 2">
                                    di sollevare ed esonerare nel modo più ampio, da ogni responsabilità connessa a
                                    quanto riportato sopra, il Dott. Evangelista Pierluca, in qualità di legale
                                    rappresentante della Società “TEVANPAL CONSULT SRL UNIPERSONALE” incaricata alla
                                    predisposizione della “Domanda Nuova Sabatini” (compresa la gestione della
                                    rendicontazione) e alla predisposizione della pratica denominata “Credito d’imposta
                                    4.0”, da qualsivoglia e da tutte le responsabilità per un’eventuale perdita del
                                    contributo;
                                </li>
                                <li>
                                    e pertanto, di rinunciare a qualsiasi e a tutte le richieste di risarcimento e di
                                    rimborso presenti o rivendicabili in futuro nei confronti del Dott. Evangelista
                                    Pierluca e della società “TEVANPAL CONSULT SRL UNIPERSONALE” ed a tutte le azioni ad
                                    essa
                                    relative, nonché a qualsivoglia tipo di procedimento giudiziario e/o arbitrale.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[1]">
                                    Acconsento
                                </mat-checkbox>
                            </div>
                            <div *ngIf="getMissingFieldsStep5().length > 0"
                                 class="alert alert-danger text-left m-t-30">
                                <strong>Per proseguire devi accettare entrambe le voci:</strong>
                                <ul style="margin-bottom: 0; padding-left: 20px;">
                                    <li *ngFor="let field of getMissingFieldsStep5()">
                                        {{ field }}
                                    </li>
                                </ul>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()"
                                        [disabled]="!canAdvanceFromCurrentStep()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 5 && request.FKIDRequestType === 6" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 release-acceptance">
                            <p>
                                La società {{ customer.CompanyName }} con sede in {{ customer.HeadOffice }} in persona del
                                legale rappresentante pro tempore signor {{ customer.Name }} {{ customer.Surname }}
                            </p>
                            <ul class="list-requests">
                                <li>
                                    messo a conoscenza della normativa relativa alla Domanda Nuova Sabatini che comprende : decreto ministeriale 18 giugno 2025 - Adeguamento della disciplina degli incentivi di competenza della DGIAI all’obbligo di stipula di contratti assicurativi a copertura dei danni cagionati da calamità naturali ed eventi catastrofali; circolare direttoriale 22 luglio 2024, n. 1115 che integra e modifica la circolare n. 410823, del 6 dicembre 2022 e ss.mm.ii. ; circolare direttoriale 11 dicembre 2023, n. 50031 ; Circolare direttoriale 6 dicembre 2022, n. 410823 ; Decreto interministeriale 22 aprile 2022 , ed ogni ulteriore normativa che disciplina l'agevolazione in oggetto;
                                </li>
                                <li>
                                    messo a conoscenza della Circolare 15 febbraio 2017 n.14036. “ 7.6 , Con riferimento alla stessa domanda, gli investimenti dichiarati dalla PMI come investimenti in tecnologie digitali e investimenti in sistemi di tracciamento e pesatura dei rifiuti, se non rientranti negli elenchi di cui agli allegati 6/A e 6/B, non sono ammessi alle agevolazioni e non possono, in tale caso, essere ammessi come investimenti ordinari”;
                                </li>
                                <li>
                                    messo a conoscenza delle condizioni da rispettare per l’accesso all’agevolazione “Domanda Nuova Sabatini” tramite email inviata alla casella di posta elettronica;
                                </li>
                                <li>
                                    messo a conoscenza che il servizio prestato rientra nell’ambito dei rapporti di consulenza, l’oggetto dell’obbligazione di mezzi è una prestazione conforme al criterio della diligenza sancito dall’art. 1176 cod. civ. , a prescindere dal raggiungimento dell’obiettivo. Non si rientra per tale motivo nella fattispecie di obbligazioni di risultato disciplinate dall’art. 1218 cod. civ.
                                </li>
                                <li>
                                    messo a conoscenza che il comma 427 dell’art. 1 della Legge 199/2025 riconosce il beneficio ai soggetti titolari di reddito d’impresa che effettuano investimenti in beni strumentali nuovi destinati a strutture produttive ubicate in Italia. Rientrano tra i beneficiari tutte le imprese, indipendentemente dalla forma giuridica (società di capitali, società di persone, ditte individuali), nonché le stabili organizzazioni di soggetti non residenti e gli enti non commerciali, limitatamente all’attività commerciale esercitata;
                                </li>
                                <li>
                                    messo a conoscenza che sono esclusi dall’agevolazione i soggetti che non producono reddito d’impresa o che presentano profili di crisi o irregolarità. In particolare, restano esclusi: professionisti e lavoratori autonomi, anche in forma associata; soggetti in regime forfettario, per l’inapplicabilità degli ammortamenti; imprese in stato di crisi o sottoposte a procedure concorsuali, anche in fase di accertamento; imprese destinatari di sanzioni interdittive ai sensi del D.Lgs. 231/2001;
                                </li>
                                <li>
                                    messo a conoscenza che l’accesso all’iperammortamento 2026 è subordinato al rispetto di specifici requisiti di compliance, la cui violazione comporta la decadenza dal beneficio. In particolare, è richiesto: il rispetto delle norme in materia di sicurezza sul lavoro, sia sotto il profilo formale che sostanziale; la regolarità contributiva, attestata dal possesso di un DURC valido al momento della fruizione dell’agevolazione;
                                </li>
                                <li>
                                    messo a conoscenza che il comma 429 della Legge 199/2025 individua due categorie di beni agevolabili ai fini dell’iperammortamento: beni strumentali materiali e immateriali nuovi inclusi negli allegati IV e V, a condizione che siano interconnessi ai sistemi aziendali; beni “green” destinati all’autoproduzione di energia da fonti rinnovabili per autoconsumo, inclusi i sistemi di stoccaggio. Con riferimento all'autoproduzione e all'autoconsumo di energia da fonte solare, sono considerati agevolabili esclusivamente gli impianti con moduli fotovoltaici di cui all'articolo 12, comma 1, lettere b) e c), del decreto-legge 9 dicembre 2023, n. 181";
                                </li>
                                <li>
                                    messo a conoscenza che l’iperammortamento si applica mediante una maggiorazione percentuale del costo del bene, articolata per scaglioni progressivi. La maggiorazione è pari a: 180% per investimenti fino a 2,5 milioni; 100% per la quota da 2,5 a 10 milioni; 50% per la quota da 10 a 20 milioni; nessuna maggiorazione oltre i 20 milioni. La fascia di investimento è su base annuale;
                                </li>
                                <li>
                                    messo a conoscenza che per i beni con costo unitario superiore a 300.000 euro è obbligatoria la perizia tecnica asseverata (o attestato di conformità di ente accreditato). Per i beni di importo pari o inferiore a 300.000 euro è ammessa la dichiarazione sostitutiva del legale rappresentante; tuttavia, la perizia asseverata è sempre fortemente consigliata ai fini della tutela dell’impresa in caso di controlli. La perizia deve attestare che il bene: rientra negli allegati IV o V; è interconnesso ai sistemi aziendali (requisito essenziale). Per gli investimenti in energie rinnovabili, la perizia deve inoltre attestare i requisiti di autoproduzione e autoconsumo.La perizia può essere rilasciata esclusivamente da ingegneri o periti industriali abilitati (o enti accreditati), dotati di adeguata copertura assicurativa; nel settore agricolo sono ammessi anche professionisti agrari abilitati. È infine richiesta una certificazione contabile delle spese, rilasciata da revisore legale o società di revisione;
                                </li>
                                <li>
                                    messo a conoscenza che l’impresa deve trasmettere al MIMIT, tramite piattaforma GSE, tre comunicazioni: 1. Comunicazione preventiva, con i dati dell’impresa e l’importo degli investimenti programmati; 2. Comunicazione di conferma, da inviare entro 60 giorni dalla ricevuta GSE, attestando il pagamento di almeno il 20% dell’investimento; 3. Comunicazione di completamento, a investimento ultimato (e comunque entro il 15 novembre 2028), con perizie, attestazioni e certificazioni.<br />Il GSE effettua verifiche formali e rilascia l’esito o richiede integrazioni entro termini prefissati;
                                </li>
                                <li>
                                    messo a conoscenza che il meccanismo di recapture prevede la revoca dell’iperammortamento residuo se il bene agevolato viene ceduto o destinato all’estero prima del termine dell’ammortamento. La revoca non opera se, nello stesso periodo d’imposta, il bene è sostituito con un altro bene nuovo 4.0 con caratteristiche analoghe o superiori, proseguendo l’agevolazione entro il limite del costo originario.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[0]">
                                    Acconsento
                                </mat-checkbox>
                            </div>

                            <p class="text-center"><strong>dichiara:</strong></p>
                            <ul class="list-requests">
                                <li>
                                    di sollevare ed esonerare nel modo più ampio, da ogni responsabilità connessa a quanto riportato sopra, il Dott. Evangelista Pierluca, in qualità di legale rappresentante della Società “TEVANPAL CONSULT SRL UNIPERSONALE” incaricata alla predisposizione della “Domanda Nuova Sabatini” e “Iperammortamento 4.0” e alla gestione della rendicontazione, da qualsivoglia e da tutte le responsabilità per un’eventuale perdita del contributo;
                                </li>
                                <li>
                                    e pertanto, di rinunciare a qualsiasi e a tutte le richieste di risarcimento e di rimborso presenti o rivendicabili in futuro nei confronti del Dott. Evangelista Pierluca e della società “TEVANPAL CONSULT SRL UNIPERSONALE” ed a tutte le azioni ad essa relative, nonché a qualsivoglia tipo di procedimento giudiziario e/o arbitrale.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[1]">
                                    Acconsento
                                </mat-checkbox>
                            </div>
                            <div *ngIf="getMissingFieldsStep5().length > 0"
                                 class="alert alert-danger text-left m-t-30">
                                <strong>Per proseguire devi accettare entrambe le voci:</strong>
                                <ul style="margin-bottom: 0; padding-left: 20px;">
                                    <li *ngFor="let field of getMissingFieldsStep5()">
                                        {{ field }}
                                    </li>
                                </ul>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()"
                                        [disabled]="!canAdvanceFromCurrentStep()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 5 && request.FKIDRequestType === 7" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 release-acceptance">
                            <p>
                                La società {{ customer.CompanyName }} con sede in {{ customer.HeadOffice }} in persona del
                                legale rappresentante pro tempore signor {{ customer.Name }} {{ customer.Surname }}
                            </p>
                            <ul class="list-requests">
                                <li>
                                    messo a conoscenza che il servizio prestato rientra nell’ambito dei rapporti di consulenza, l’oggetto dell’obbligazione di mezzi è una prestazione conforme al criterio della diligenza sancito dall’art. 1176 cod. civ. , a prescindere dal raggiungimento dell’obiettivo. Non si rientra per tale motivo nella fattispecie di obbligazioni di risultato disciplinate dall’art. 1218 cod. civ.
                                </li>
                                <li>
                                    messo a conoscenza che il comma 427 dell’art. 1 della Legge 199/2025 riconosce il beneficio ai soggetti titolari di reddito d’impresa che effettuano investimenti in beni strumentali nuovi destinati a strutture produttive ubicate in Italia. Rientrano tra i beneficiari tutte le imprese, indipendentemente dalla forma giuridica (società di capitali, società di persone, ditte individuali), nonché le stabili organizzazioni di soggetti non residenti e gli enti non commerciali, limitatamente all’attività commerciale esercitata;
                                </li>
                                <li>
                                    messo a conoscenza che sono esclusi dall’agevolazione i soggetti che non producono reddito d’impresa o che presentano profili di crisi o irregolarità. In particolare, restano esclusi: professionisti e lavoratori autonomi, anche in forma associata; soggetti in regime forfettario, per l’inapplicabilità degli ammortamenti; imprese in stato di crisi o sottoposte a procedure concorsuali, anche in fase di accertamento; imprese destinatari di sanzioni interdittive ai sensi del D.Lgs. 231/2001;
                                </li>
                                <li>
                                    messo a conoscenza che l’accesso all’iperammortamento 2026 è subordinato al rispetto di specifici requisiti di compliance, la cui violazione comporta la decadenza dal beneficio. In particolare, è richiesto: il rispetto delle norme in materia di sicurezza sul lavoro, sia sotto il profilo formale che sostanziale; la regolarità contributiva, attestata dal possesso di un DURC valido al momento della fruizione dell’agevolazione;
                                </li>
                                <li>
                                    messo a conoscenza che il comma 429 della Legge 199/2025 individua due categorie di beni agevolabili ai fini dell’iperammortamento: beni strumentali materiali e immateriali nuovi inclusi negli allegati IV e V, a condizione che siano interconnessi ai sistemi aziendali; beni “green” destinati all’autoproduzione di energia da fonti rinnovabili per autoconsumo, inclusi i sistemi di stoccaggio. Con riferimento all'autoproduzione e all'autoconsumo di energia da fonte solare, sono considerati agevolabili esclusivamente gli impianti con moduli fotovoltaici di cui all'articolo 12, comma 1, lettere b) e c), del decreto-legge 9 dicembre 2023, n. 181";
                                </li>
                                <li>
                                    messo a conoscenza che L’iperammortamento si applica mediante una maggiorazione percentuale del costo del bene, articolata per scaglioni progressivi. La maggiorazione è pari a: 180% per investimenti fino a 2,5 milioni; 100% per la quota da 2,5 a 10 milioni; 50% per la quota da 10 a 20 milioni; nessuna maggiorazione oltre i 20 milioni. La fascia di investimento è su base annuale;
                                </li>
                                <li>
                                    messo a conoscenza che per i beni con costo unitario superiore a 300.000 euro è obbligatoria la perizia tecnica asseverata (o attestato di conformità di ente accreditato). Per i beni di importo pari o inferiore a 300.000 euro è ammessa la dichiarazione sostitutiva del legale rappresentante; tuttavia, la perizia asseverata è sempre fortemente consigliata ai fini della tutela dell’impresa in caso di controlli. La perizia deve attestare che il bene: rientra negli allegati IV o V; è interconnesso ai sistemi aziendali (requisito essenziale). Per gli investimenti in energie rinnovabili, la perizia deve inoltre attestare i requisiti di autoproduzione e autoconsumo.La perizia può essere rilasciata esclusivamente da ingegneri o periti industriali abilitati (o enti accreditati), dotati di adeguata copertura assicurativa; nel settore agricolo sono ammessi anche professionisti agrari abilitati. È infine richiesta una certificazione contabile delle spese, rilasciata da revisore legale o società di revisione;
                                </li>
                                <li>
                                    messo a conoscenza che l’impresa deve trasmettere al MIMIT, tramite piattaforma GSE, tre comunicazioni: 1. Comunicazione preventiva, con i dati dell’impresa e l’importo degli investimenti programmati; 2. Comunicazione di conferma, da inviare entro 60 giorni dalla ricevuta GSE, attestando il pagamento di almeno il 20% dell’investimento; 3. Comunicazione di completamento, a investimento ultimato (e comunque entro il 15 novembre 2028), con perizie, attestazioni e certificazioni.<br />Il GSE effettua verifiche formali e rilascia l’esito o richiede integrazioni entro termini prefissati;
                                </li>
                                <li>
                                    messo a conoscenza che il meccanismo di recapture prevede la revoca dell’iperammortamento residuo se il bene agevolato viene ceduto o destinato all’estero prima del termine dell’ammortamento. La revoca non opera se, nello stesso periodo d’imposta, il bene è sostituito con un altro bene nuovo 4.0 con caratteristiche analoghe o superiori, proseguendo l’agevolazione entro il limite del costo originario.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[0]">
                                    Acconsento
                                </mat-checkbox>
                            </div>

                            <p class="text-center"><strong>dichiara:</strong></p>
                            <ul class="list-requests">
                                <li>
                                    di sollevare ed esonerare nel modo più ampio, da ogni responsabilità connessa a quanto riportato sopra, il Dott. Evangelista Pierluca, in qualità di legale rappresentante della Società “TEVANPAL CONSULT SRL UNIPERSONALE” incaricata alla predisposizione della pratica relativa a “Iperammortamento 4.0” e alla gestione della rendicontazione, da qualsivoglia e da tutte le responsabilità per un’eventuale perdita del contributo;
                                </li>
                                <li>
                                    e pertanto, di rinunciare a qualsiasi e a tutte le richieste di risarcimento e di rimborso presenti o rivendicabili in futuro nei confronti del Dott. Evangelista Pierluca e della società “TEVANPAL CONSULT SRL UNIPERSONALE” ed a tutte le azioni ad essa relative, nonché a qualsivoglia tipo di procedimento giudiziario e/o arbitrale.
                                </li>
                            </ul>
                            <div>
                                <mat-checkbox color="primary" class="release-checkbox" [(ngModel)]="checkboxRelease[1]">
                                    Acconsento
                                </mat-checkbox>
                            </div>
                            <div *ngIf="getMissingFieldsStep5().length > 0"
                                 class="alert alert-danger text-left m-t-30">
                                <strong>Per proseguire devi accettare entrambe le voci:</strong>
                                <ul style="margin-bottom: 0; padding-left: 20px;">
                                    <li *ngFor="let field of getMissingFieldsStep5()">
                                        {{ field }}
                                    </li>
                                </ul>
                            </div>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()"
                                        [disabled]="!canAdvanceFromCurrentStep()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 6 && request.FKIDRequestType !== 7" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 attorney-acceptance">
                            <p>
                                Il/La sottoscritto/a Sig./Sig.ra {{ customer.Name }} {{ customer.Surname }} nato/a a
                                {{ customer.BirthPlace }} il {{ customer.BirthDate | date:'dd/MM/yyyy' }}, residente a {{ customer.City }}, 
                                in qualità di legale rappresentante della Società/Ditta
                                Individuale {{ customer.CompanyName }} con P.IVA n. {{ customer.VATNumber }} viste le disposizione contenute negli
                                articoli 21, 38, 47 e 76 del decreto del Presidente della Repubblica 28 dicembre 2000,
                                n. 445, con la presente
                            </p>
                            <p class="text-center bold">
                                conferisce PROCURA SPECIALE
                            </p>
                            <p>
                                Al Dott. Commercialista Evangelista Pierluca nato a Roma il 02/09/1998 e residente in
                                via Nomentana 353 Comune di Fonte Nuova, C.F. VNGPLC98P02H501M in qualità di legale
                                rappresentante della società “TEVANPAL CONSULT SRL UNIPERSONALE” avente sede legale in
                                Via Nomentana
                                351/A Fonte Nuova (RM), con P.I. e C.F. 17772961003, <strong><u>con l’incarico di
                                sottoscrivere con
                                firma digitale ed inviare tramite Posta Elettronica Certificata</u></strong>, alla banca
                                prescelta, la domanda per accedere ad un finanziamento ai sensi art. 2 D.L. 69 del
                                21/06/13 convertito con modificazioni nella legge 9/08/13, n. 98 e per accedere alle
                                agevolazioni di cui all’art. 6 DM 27/11/2013 (denominata “Domanda Nuova Sabatini”),
                                pubblicato sulla Gazzetta Ufficiale del 24/01/2014 n. 19, il D.L. n. 3 del 24/01/2015
                                convertito con modificazioni nella legge 24/03/15, n. 33 ed il decreto interministeriale
                                25/01/2016, pubblicato sulla Gazzetta Ufficiale del 10/03/2016 n. 58 in relazione al
                                finanziamento/ leasing di beni strumentali, delegandolo alla presentazione ed al
                                successivo espletamento di ogni attività connessa a tale procedimento e attribuendogli
                                allo scopo ogni più ampia facoltà di legge, con promessa fin d’ora di rato e valido del
                                suo operato. Il modulo per la richiesta di finanziamento verrà inviato tramite indirizzo
                                PEC / mail TEVANPALCONSULTSRL@LEGALMAIL.IT.
                            </p>
                            <p>
                                Il sottoscritto DICHIARA inoltre, ai sensi e per gli effetti dell’art. 47 del D.P.R.
                                445/2000, consapevole delle responsabilità penali di cui all’art. 76 del medesimo D.P.R.
                                445/2000 per le ipotesi di falsità in atti e dichiarazioni mendaci in relazione alla
                                pratica presentata:
                            </p>
                            <ol>
                                <li>
                                    La veridicità di tutte le dichiarazioni rese e sottoscritte;
                                </li>
                                <li>
                                    Che le copie dei documenti allegati sono conformi agli originali;
                                </li>
                                <li>
                                    Di eleggere domicilio speciale, per tutti gli atti e le comunicazioni inerenti il
                                    procedimento amministrativo, presso l’indirizzo di posta elettronica del soggetto
                                    che provvede alla trasmissione telematica a cui viene conferita la facoltà di
                                    eseguire eventuali rettifiche di errori formali inerenti la modulistica elettronica.
                                </li>
                            </ol>
                            <p class="text-uppercase text-center bold m-t-30">
                                Dichiarazione sostitutiva dell'atto di notorietà resa dal procuratore
                            </p>
                            <p>
                                Colui che, in qualità di procuratore, sottoscrive con firma digitale la copia
                                informativa del presente documento, consapevole delle responsabilità penali di cui
                                all’articolo 76 del medesimo D.P.R. 445/2000 per le ipotesi di falsità in atti e
                                dichiarazioni mendaci,
                            </p>
                            <p class="text-center text-uppercase">dichiara</p>
                            <ol>
                                <li>
                                    Ai sensi dell’art. 46.1 lett. u) del D.P.R. 445/2000 di agire in qualità di
                                    procuratore speciale in rappresentanza dei soggetti che hanno apposto la propria
                                    firma nel presente documento;
                                </li>
                                <li>
                                    Che le dichiarazioni contenute nella domanda presentata unitamente alla presente
                                    procura speciale, corrispondono a quelle rese dal dichiarante;
                                </li>
                                <li>
                                    Che le copie informatiche degli eventuali documenti allegati alla domanda
                                    corrispondono ai documenti consegnati dal dichiarante e conservati in originale
                                    presso la sede del proprio studio.
                                </li>
                            </ol>
                            <p>Allegati:</p>
                            <ol>
                                <li>Documento di identità del delegante</li>
                                <li>Riepilogo documentazione inviata.</li>
                            </ol>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 7 && request.FKIDRequestType !== 7" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2 list-acceptance">
                            <ol type="1">
                                <li><strong>Premessa</strong>
                                    <ol type="1">
                                        <li *ngIf="request.FKIDRequestType !== 2 && request.FKIDRequestType !== 6">
                                            La Societa’ “Tevanpal Consult Srl Unipersonale”, con sede in Fonte Nuova –
                                            Roma – Via Nomentana n.351/A – C.F. 17772961003, P. Iva 17772961003: (il
                                            “Società incaricata”), fornisce servizi professionali per la predisposizione
                                            e gestione della pratica denominata “Domanda Nuova Sabatini” (i “Servizi”).
                                        </li>
                                        <li *ngIf="request.FKIDRequestType === 2">
                                            La Societa’ “Tevanpal Consult Srl Unipersonale”, con sede in Fonte Nuova –
                                            Roma – Via Nomentana n.351/A – C.F. 17772961003, P. Iva 17772961003: (il
                                            “Società incaricata”), fornisce servizi professionali per la predisposizione
                                            e gestione pratiche denominate “Domanda Nuova Sabatini” e “Credito d’imposta
                                            4.0” (i “Servizi”).
                                        </li>
                                        <li *ngIf="request.FKIDRequestType === 6">
                                            La Societa’ “Tevanpal Consult Srl Unipersonale”, con sede in Fonte Nuova –
                                            Roma – Via Nomentana n.351/A – C.F. 17772961003, P. Iva 17772961003: (il
                                            “Società incaricata”), fornisce servizi professionali per la predisposizione
                                            e gestione pratiche denominate “Domanda Nuova Sabatini” e “Iperammortamento 4.0” (i “Servizi”).
                                        </li>
                                        <li>
                                            I termini di seguito scritti in maiuscolo, ove non già definiti, hanno il
                                            significato ad essi attribuito nella successiva
                                            Sezione 2.
                                        </li>
                                        <li>
                                            Ove il Cliente finale sceglierà di voler usufruire dei Servizi offerti dalla
                                            Società incaricata, la stessa, in qualità di Titolare del trattamento dei
                                            Dati personali, tratterà i Dati personali dei Clienti finali, alle
                                            condizioni previste nel presente documento.
                                        </li>
                                        <li>
                                            Tutto quanto sopra premesso, il Cliente riceve dall’esecutore dei lavori il
                                            presente documento, con il quale il
                                            Professionista fornisce al Cliente le informazioni previste dal Regolamento.
                                        </li>
                                    </ol>
                                </li>

                                <li><strong>Definizioni</strong>
                                    <ol type="1">
                                        <li>
                                            Nel presente documento per "Disciplina in materia di protezione dei dati
                                            personali" si intendono: (i) il
                                            Regolamento generale dell'UE n. 2016/679 relativo alla protezione delle
                                            persone
                                            fisiche con riguardo al trattamento dei
                                            dati personali, nonché della libera circolazione di tali dati
                                            (“Regolamento”),
                                            (ii) ogni ulteriore legge, atto avente forza
                                            di legge e/o regolamento in materia di protezione dei dati personali
                                            applicabile;
                                        </li>
                                        <li>
                                            I termini di seguito elencati avranno il significato agli stessi attribuito
                                            di
                                            seguito, nonché nella Disciplina in materia
                                            di protezione dei dati personali:
                                            <ul>
                                                <li>
                                                    “Dati personali”: qualsiasi informazione riguardante una persona
                                                    fisica
                                                    identificata o identificabile ricevuti dal
                                                    Installatore e/o dal Cliente per conto del Titolare sono ricompresi
                                                    nelle seguenti categorie: dati comuni (nome,
                                                    cognome, codice fiscale, indirizzo, indirizzo e-mail);
                                                </li>
                                                <li>
                                                    “Persona interessata”: I dati personali sono trattati dal Titolare
                                                    del
                                                    trattamento, come di seguito definito, o per conto
                                                    dello stesso, nell’ambito del Contratto;
                                                </li>
                                                <li>
                                                    “Titolare del trattamento": La Società incaricata che, singolarmente
                                                    o
                                                    insieme ad altri, determina le finalità e i mezzi del
                                                    trattamento di Dati personali; quando le finalità e i mezzi di tale
                                                    trattamento sono determinati dal diritto dell’Unione
                                                    europea o degli Stati membri, il Titolare del trattamento o i
                                                    criteri
                                                    specifici applicabili alla sua designazione possono
                                                    essere stabiliti dal diritto dell’Unione europea o degli Stati
                                                    membri;
                                                </li>
                                                <li>
                                                    “Responsabile del trattamento”: la persona fisica o giuridica che
                                                    tratta
                                                    Dati personali per conto del Titolare del
                                                    trattamento ai sensi dell’art. 28 del Regolamento, individuato
                                                    secondo
                                                    quanto descritto nella Sezione 6;
                                                </li>
                                                <li>
                                                    “Responsabile della protezione dei dati”: la figura disciplinata
                                                    dall’art. 37 del Regolamento contattabile all’indirizzo
                                                    e-mail direzione@tevanpal.it;
                                                </li>
                                                <li>
                                                    “Destinatario”: il soggetto cui il Titolare e/o il Responsabile
                                                    possono
                                                    comunicare i Dati personali, in quanto rientrante
                                                    in una delle categorie individuate nella Sezione 6;
                                                </li>
                                                <li>
                                                    “Familiari”: il coniuge o convivente more uxorio, i figli e
                                                    familiari a
                                                    carico della Persona interessata, nonché gli altri
                                                    soggetti che da quella dipendono o che le sono strettamente legati;
                                                </li>
                                                <li>
                                                    “Trattamento”: qualsiasi operazione o insieme di operazioni,
                                                    compiute
                                                    con o senza l’ausilio di processi automatizzati
                                                    e applicate a Dati personali o insiemi di Dati personali, come la
                                                    raccolta, la registrazione, l’organizzazione, la
                                                    strutturazione, la conservazione, l’adattamento o la modifica,
                                                    l’estrazione, la consultazione, l’uso, la comunicazione
                                                    mediante trasmissione, diffusione o qualsiasi altra forma di messa a
                                                    disposizione, il raffronto o l’interconnessione, la
                                                    limitazione, la cancellazione o la distruzione.
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>
                                </li>

                                <li><strong>Finalità del Trattamento</strong>
                                    <ol type="1">
                                        <li>
                                            Il Titolare tratterà i Dati personali della Persona interessata per finalità
                                            funzionali all’esecuzione dell’incarico Professionale e, in particolare,
                                            per: a. l’assistenza nell’ambito della gestione della “Domanda Nuova
                                            Sabatini”<span *ngIf="request.FKIDRequestType === 2"> e “Credito d’imposta 4.0”</span>
                                            – a titolo esemplificativo e non esaustivo - delle seguenti attività:
                                            <ul>
                                                <li>
                                                    raccolta di informazioni e analisi della documentazione a rilevanza
                                                    fiscale fornita dal Cliente;
                                                </li>
                                                <li>
                                                    acquisizione della offerte di acquisto del bene o dei beni
                                                    strumentali
                                                    oggetto di investimento;
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            La Persona interessata è informata che il conferimento dei Dati personali è
                                            necessario per le altre finalità di cui
                                            sopra con la conseguenza che, in mancanza, il Titolare non potrà dare
                                            esecuzione
                                            agli obblighi previsti nel Contratto,
                                            fermo restando che ciò non ne costituirà inadempimento.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Base giuridica del Trattamento</strong>
                                    <ol type="1">
                                        <li>
                                            Per le finalità di cui alla Sezione 3 il Titolare effettuerà la raccolta e
                                            il
                                            Trattamento dei Dati della Persona interessata
                                            sulla base delle seguenti condizioni di liceità: (i) esecuzione
                                            dell’incarico,
                                            (ii) adempimento di obblighi di legge, (iii)
                                            legittimo interesse allo svolgimento dell’attività istituzionale e
                                            organizzativa
                                            del Professionista.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Modalità e durata del Trattamento</strong>
                                    <ol type="1">
                                        <li>
                                            Nel rispetto della Disciplina in materia di protezione dei dati personali e
                                            secondo quanto previsto dalle autorità
                                            competenti, il Titolare del trattamento:
                                            <ol type="a">
                                                <li>
                                                    tratterà i Dati personali della Persona interessata nella misura
                                                    necessaria per l’adempimento delle obbligazioni
                                                    derivanti dal Contratto;
                                                </li>
                                                <li>
                                                    tratterà i Dati personali della Persona interessata anche in
                                                    modalità
                                                    elettronica, mediante strumenti idonei a garantirne
                                                    la sicurezza e la riservatezza, avvalendosi del supporto di mezzi
                                                    cartacei, informatici o telematici atti a memorizzare,
                                                    gestire e, ove necessario, trasmettere i Dati personali stessi;
                                                </li>
                                                <li>
                                                    si impegna a mettere in atto misure tecniche organizzative
                                                    appropriate
                                                    per garantire un livello di sicurezza adeguato
                                                    al rischio di violazione dei Dati personali;
                                                </li>
                                                <li>
                                                    tratterà i Dati personali della Persona interessata nel rispetto
                                                    delle
                                                    modalità indicate dalla Disciplina in materia di
                                                    protezione dei dati personali applicabile, che prevede in
                                                    particolare
                                                    che i Dati personali siano: (i) trattati in modo lecito,
                                                    corretto e trasparente, (ii) raccolti e registrati per scopi
                                                    determinati, espliciti e legittimi, (iii) esatti e, se necessario,
                                                    aggiornati, (iv) pertinenti, completi e non eccedenti rispetto alle
                                                    finalità del trattamento;
                                                </li>
                                                <li>
                                                    non comunicherà alcun Dato a soggetti diversi dai Destinatari;
                                                </li>
                                                <li>
                                                    comunicherà alla Persona interessata i dati dell’eventuale
                                                    Responsabile
                                                    del trattamento e degli eventuali Destinatari;
                                                </li>
                                                <li>
                                                    garantisce che l’eventuale Responsabile del trattamento: (i)
                                                    adempierà
                                                    agli obblighi che su di esso gravano in virtù
                                                    della Disciplina in materia di protezione dei dati personali
                                                    applicabile
                                                    e (ii) si atterrà alle istruzioni dettate dal Titolare
                                                    del trattamento;
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            Il Titolare dichiara di non porre in essere processi decisionali basati
                                            unicamente sul Trattamento automatizzato,
                                            compresa la profilazione, che producano effetti giuridici sulla Persona
                                            interessata.
                                        </li>
                                        <li>
                                            I Dati personali saranno trattati dalle Persone autorizzate al Trattamento,
                                            come
                                            di seguito definite, che agiscono
                                            sotto l’autorità del Titolare secondo quanto previsto dal successivo
                                            paragrafo
                                            6.3.
                                        </li>
                                        <li>
                                            I Dati personali della Persona interessata verranno trattati per tutta la
                                            durata
                                            del Contratto e anche successivamente,
                                            nella misura in cui ciò sia necessario (i) all’adempimento degli obblighi
                                            previsti dalla Disciplina in materia di protezione
                                            dei dati personali applicabile e/o da eventuali ordini di una pubblica
                                            autorità,
                                            nonché di eventuali altri obblighi di natura
                                            civilistica, fiscale e tributaria vigenti e (ii) all’esercizio del diritto
                                            di
                                            difesa nell’ambito di eventuali controversie sorte
                                            in relazione all’esecuzione del Contratto.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Responsabili dei Trattamento, Persone autorizzate al Trattamento,
                                        Destinatari
                                        dei Dati</strong>
                                    <ol type="1">
                                        <li>
                                            Il Titolare ha individuato un Responsabile della protezione dei dati
                                            personali
                                            ex art. 37 del regolamento,
                                            contattabile all’indirizzo email: direzione@tevanpal.it.
                                        </li>
                                        <li>
                                            Nell’ambito dell’esecuzione dell’incarico, sotto la propria diretta
                                            autorità, il
                                            Titolare e gli eventuali Responsabili
                                            possono nominare, ai sensi dell’art. 4, n. 10 del Regolamento, delle persone
                                            autorizzate al Trattamento dei Dati della
                                            Persona interessata (di seguito la “Persona autorizzata”). La Persona
                                            autorizzata svolgerà il Trattamento dei Dati
                                            personali ad essa trasmessi, nel rispetto degli obblighi previsti dalla
                                            Disciplina in materia di protezione dei dati
                                            personali e alle condizioni fissate dal Titolare e dagli eventuali
                                            Responsabili.
                                        </li>
                                        <li>
                                            Ai fini dell’esecuzione degli obblighi nascenti dal Contratto e per il
                                            perseguimento delle finalità precedentemente
                                            indicate, il Titolare potrà comunicare i Dati personali della Persona
                                            interessata, tra l’altro, ai seguenti Destinatari, che
                                            tratteranno i Dati personali in qualità di Titolari autonomi oppure
                                            Responsabili:
                                            <ol type="a">
                                                <li>
                                                    autorità pubbliche, enti pubblici e chiunque debba essere
                                                    destinatario
                                                    dei Dati personali in forza di leggi, atti aventi
                                                    forza di legge, regolamenti, ordini di pubblica autorità, obblighi
                                                    contrattuali;
                                                </li>
                                                <li>
                                                    enti previdenziali e casse di previdenza;
                                                </li>
                                                <li>
                                                    organismi sanitari, personale medico e paramedico, studi medici in
                                                    adempimento degli obblighi in materia di igiene e
                                                    sicurezza dei luoghi di lavoro ed ogni altro adempimento legato allo
                                                    svolgimento del rapporto di lavoro, ove applicabile;
                                                </li>
                                                <li>
                                                    imprese di assicurazione;
                                                </li>
                                                <li>
                                                    banche, istituti di credito, intermediari finanziari non bancari;
                                                </li>
                                                <li>
                                                    familiari e soggetti i cui nominativi siano stati eventualmente
                                                    forniti
                                                    dalla Persona interessata per comunicazioni di
                                                    emergenza.
                                                </li>
                                            </ol>
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Diritti della Persona interessata</strong>
                                    <ol type="1">
                                        <li>
                                            Il Titolare riconosce e garantisce alla Persona interessata il rispetto dei
                                            seguenti diritti:
                                            <ol type="a">
                                                <li>
                                                    di accesso ai Dati personali presenti in propri archivi cartacei e/o
                                                    elettronici e di ottenere una copia degli stessi;
                                                </li>
                                                <li>
                                                    di chiedere la rettifica se i Dati personali sono incompleti o
                                                    erronei e
                                                    di ottenerla senza ingiustificato ritardo;
                                                </li>
                                                <li>
                                                    di chiedere l’aggiornamento e l’integrazione se i Dati personali
                                                    sono
                                                    incompleti o erronei, anche fornendo una
                                                    dichiarazione integrativa;
                                                </li>
                                                <li>
                                                    di chiedere la cancellazione dei Dati personali se sussiste uno dei
                                                    motivi di cui all’art. 17, comma 1 del Regolamento
                                                    e di ottenerla senza ingiustificato ritardo;
                                                </li>
                                                <li>
                                                    di ottenere la limitazione del Trattamento quando ricorre una delle
                                                    ipotesi di cui all’art. 18, comma 1 del
                                                    Regolamento;
                                                </li>
                                                <li>
                                                    alla portabilità dei Dati personali nei limiti e nei modi previsti
                                                    dall’art. 20 del Regolamento;
                                                </li>
                                                <li>
                                                    di opporsi al Trattamento dei Dati personali per motivi legittimi e
                                                    specifici;
                                                </li>
                                                <li>
                                                    di proporre reclamo al Garante per la protezione dei dati personali
                                                    o
                                                    ricorso dinanzi all'autorità giudiziaria.
                                                </li>
                                            </ol>
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Varie</strong>
                                    <ol type="1">
                                        <li>
                                            La Società di Consulenza si riserva il diritto di modificare il contenuto
                                            delle
                                            Sezioni che precedono, dandone adeguata informazione alla Persona
                                            interessata.
                                        </li>
                                        <li>
                                            I diritti della Persona interessata di cui alla Sezione 8 possono essere
                                            esercitati mediante l’invio
                                            di una pec: <a href="mailto:tevanpalconsultsrl@legalmail.it">TEVANPALCONSULTSRL@LEGALMAIL.IT</a>
                                            . Allo stesso indirizzo possono essere altresì rivolte eventuali
                                            domande o segnalazioni relative alla presente Informativa e al Trattamento
                                            dei
                                            Dati personali.
                                        </li>
                                    </ol>
                                </li>
                            </ol>

                            <div class="text-center m-t-40">
                                <button type="button"
                                        class="btn btn-embossed btn-default"
                                        (click)="goStepBackward()">
                                    <i class="fa fa-arrow-left"></i>Indietro
                                </button>
                                <button type="submit"
                                        class="btn btn-embossed btn-primary"
                                        (click)="goStepForward()">
                                    <i class="glyphicon glyphicon-arrow-right"></i>Accetta e vai al passaggio successivo
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 8" class="row"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Visura Camerale aggiornata</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['1'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="chamber-commerce-certificate"
                                               name="chamber-commerce-certificate"
                                               (change)="uploadDocument($event, 1)"
                                               required>
                                        <label class="custom-file-label"
                                               for="chamber-commerce-certificate">{{ fileName[1] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['1'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['1']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Formato accettato PDF, non ammessa la scannerizzazione del documento.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Ultimo Bilancio approvato</div>
                                <div class="col-9 input-group">
                                    <div *ngIf="documentList['2'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="last-balance"
                                               name="last-balance"
                                               (change)="uploadDocument($event, 2)"
                                               required>
                                        <label class="custom-file-label"
                                               for="last-balance">{{ fileName[2] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['2'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['2']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Formato accettato PDF/DOCX, non ammessa la scannerizzazione del documento.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType !== 5 && request.FKIDRequestType !== 7" class="row m-b-10">
                                <div class="col-3 m-t-12">Marca da Bollo da 16 euro</div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['3'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="revenue-stamp"
                                               name="revenue-stamp"
                                               (change)="uploadDocument($event, 3)"
                                               required>
                                        <label class="custom-file-label"
                                               for="revenue-stamp">{{ fileName[3] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['3'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['3']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        È possibile caricare una scannerizzazione o una foto. La marca da bollo
                                        originale dovrà essere conservata, così da esibirla in caso di controlli.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">Carta di Identità del Titolare della Società/Ditta
                                    Individuale
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="id-card-owner"
                                               name="id-card-owner"
                                               (change)="uploadDocument($event, 4)"
                                               required>
                                        <label class="custom-file-label"
                                               for="id-card-owner">{{ fileName[4] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="request.FKIDRequestType === 5" class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Caricare le carte di identità di tutti i titolari effettivi indicati nella
                                        sezione 3.
                                    </div>
                                    <div *ngIf="documentList['4'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['4']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 || request.FKIDRequestType === 6 || request.FKIDRequestType === 7" class="row m-b-10">
                                <div class="col-3 m-t-12">DURC in corso di validità</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="durc"
                                               name="durc"
                                               (change)="uploadDocument($event, 8)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[8] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['8'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['8']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="(request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !request.Simplified" class="row m-b-10">
                                <div class="col-3 m-t-12">DVR</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="dvr"
                                               name="dvr"
                                               (change)="uploadDocument($event, 29)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[29] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['29'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['29']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5BusinessExpansion === 'Sostituzione'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Fatture, DDT, Verbali di consegna</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="fatture"
                                               name="fatture"
                                               (change)="uploadDocument($event, 10)"
                                               required>
                                        <label class="custom-file-label"
                                               for="fatture">{{ fileName[10] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['10'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['10']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        In caso di sostituzione del bene oggetto di investimento con uno nuovo, occorre
                                        caricare copia della fattura di acquisto, DDT e verbale di consegna del bene
                                        sostituito.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5BusinessExpansion === 'Sostituzione'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Libro cespiti da cui si evince la registrazione del bene
                                    oggetto di sostituzione
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="libro-cespiti"
                                               name="libro-cespiti"
                                               (change)="uploadDocument($event, 15)"
                                               required>
                                        <label class="custom-file-label"
                                               for="libro-cespiti">{{ fileName[15] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['15'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['15']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Si consiglia di caricare una scannerizzazione o uno screenshot del libro
                                        cespiti.
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 || ((request.FKIDRequestType === 6 || request.FKIDRequestType === 7) && !request.Simplified)"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Visura catastale della struttura produttiva</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="visura-struttura"
                                               name="visura-struttura"
                                               (change)="uploadDocument($event, 16)"
                                               required>
                                        <label class="custom-file-label"
                                               for="visura-struttura">{{ fileName[16] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['16'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['16']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="request.FKIDRequestType === 5 && request.TaxCredit5StructureOwner === 'Affittuaria'"
                                 class="row m-b-10">
                                <div class="col-3 m-t-12">Contratto di affitto della struttura produttiva</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="contratto-affitto-struttura"
                                               name="contratto-affitto-struttura"
                                               (change)="uploadDocument($event, 17)"
                                               required>
                                        <label class="custom-file-label"
                                               for="contratto-affitto-struttura">{{ fileName[17] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['17'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['17']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">Offerta del Fornitore non timbrata</div>
                                <div class="col-9 input-group mb-3">
                                    <div class="custom-file m-t-10 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="supplier-offer"
                                               name="supplier-offer"
                                               (change)="uploadDocument($event, 5)"
                                               required>
                                        <label class="custom-file-label"
                                               for="supplier-offer">{{ fileName[5] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['5'].length > 0" class="width-100p m-t-12">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['5']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Si richiede un’offerta non timbrata per poter dimostrare in caso di controlli
                                        che l'impresa non ha avviato l’investimento prima della presentazione della
                                        "Domanda Nuova Sabatini".
                                    </div>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">Contratto di Consulenza
                                    da firmare olograficamente o digitalmente
                                </div>
                                <div class="col-7 input-group mb-3">
                                    <div *ngIf="documentList['6'].length === 0" class="custom-file m-t-20 m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="privacy-warrant-attorney"
                                               name="privacy-warrant-attorney"
                                               (change)="uploadDocument($event, 6)"
                                               required>
                                        <label class="custom-file-label"
                                               for="privacy-warrant-attorney">{{ fileName[6] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['6'].length > 0" class="width-100p m-t-30">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['6']">
                                                <span *ngIf="documentDetail.Path.length <= 38"
                                                      class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path | slice:0:38 }}
                                                </span>
                                                <span *ngIf="documentDetail.Path.length > 38"
                                                      class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path | slice:0:38 }}...
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Si consiglia di caricare il contratto firmato digitalmente in P7M dal legale
                                        rappresentante dell'impresa.
                                    </div>
                                </div>
                                <div class="col-2 float-right" style="padding-top: 28px; padding-right: 0;">
                                    <button type="button"
                                            (click)="downloadDocumentsToSign()"
                                            class="btn btn-embossed btn-success btn-sm">
                                        <i class="fa fa-download" style="margin-right: 10px;"></i>Download
                                    </button>
                                </div>
                            </div>
                            <div class="row m-b-10">
                                <div class="col-3 m-t-12">
                                    Distinta di Pagamento
                                    <i (click)="openInfoPaymentModal()"
                                       class="fa fa-info-circle info-icon-box"></i>
                                </div>
                                <div class="col-9 input-group mb-3">
                                    <div *ngIf="documentList['7'].length === 0" class="custom-file m-b-12">
                                        <input type="file"
                                               class="custom-file-input"
                                               id="payment-slip"
                                               name="payment-slip"
                                               (change)="uploadDocument($event, 7)"
                                               required>
                                        <label class="custom-file-label"
                                               for="payment-slip">{{ fileName[7] || 'Nessun file selezionato' }}</label>
                                    </div>
                                    <div *ngIf="documentList['7'].length > 0" class="width-100p m-t-10">
                                        <ul style="list-style-type: none;">
                                            <li *ngFor="let documentDetail of documentList['7']">
                                                <span class="label label-success"
                                                      style="font-size: 12px; margin-right: auto;">
                                                        {{ documentDetail.Path }}
                                                </span>
                                                <button (click)="deleteDocument(documentDetail)"
                                                        type="button"
                                                        class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="info-box" style="width: 100%;">
                                        <i class="fa fa-info-circle"></i>
                                        Cliccare sulla i (qui accanto) per le istruzioni sul bonifico da effettuare
                                    </div>
                                </div>
                            </div>

                            <form #step7Form="ngForm" role="form" class="form-horizontal form-validation">
                                <div *ngIf="getMissingFieldsStep8().length > 0"
                                     class="alert alert-danger text-left m-t-30">
                                    <strong>Per inviare la documentazione mancano ancora i seguenti documenti:</strong>
                                    <ul style="margin-bottom: 0; padding-left: 20px;">
                                        <li *ngFor="let field of getMissingFieldsStep8()">
                                            {{ field }}
                                        </li>
                                    </ul>
                                </div>

                                <div class="text-center m-t-40">
                                    <button type="button"
                                            class="btn btn-embossed btn-default"
                                            (click)="goStepBackward()">
                                        <i class="fa fa-arrow-left"></i>Indietro
                                    </button>
                                    <button type="button"
                                            class="btn btn-embossed btn-primary"
                                            (click)="goStepForward()"
                                            [disabled]="!canAdvanceFromCurrentStep()">
                                        <i class="fa fa-upload"></i>Invia documentazione al Team Tevanpal
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 9" class="row session-complete"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <i class="fa fa-check-circle m-r-5"></i>Pratica inviata correttamente
                        </div>
                    </div>

                    <div *ngIf="request.ProgressStatus === 10" class="row session-complete"
                         style="margin-top: 30px; margin-bottom: 30px;">
                        <div class="col-sm-8 offset-sm-2">
                            <i class="fa fa-check-circle m-r-5"></i>Pratica completata
                        </div>
                    </div>
                </div>
                <div *ngIf="request.IDRequest === undefined" class="session-invalid">
                    Impossibile recuperare la pratica
                </div>
            </div>
        </div>
    </div>
</div>
